// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-27T21:32:38.588Z
// Property: The Pointe Of Ridgeland (ID: 6767906449167046)
// Collections: 27 amenities, 11 floorplans (live), 28 photos, 58 POIs, 4 reviews, 1 virtual tours, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162419",
  "multihub_property_id": "6767906449167046",
  "property_external_id": "48293",
  "property_zillow_url": "https://www.zillow.com/apartments/ridgeland-ms/the-pointe-of-ridgeland/5Xt49K/",
  "property_apartments_url": "https://www.apartments.com/the-pointe-at-cedar-rapids-cedar-rapids-ia/kqgvd1b/",
  "property_google_business_url": "https://www.google.com/maps/place/The+Pointe+of+Ridgeland/data=!4m2!3m1!1s0x0:0x393cf79f9974bc47?sa=X&ved=2ahUKEwijo-7qiYOTAxUSlokEHZR5GScQ_BJ6BAgWEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "5064029900",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "the-pointe-of-ridgeland",
  "property_name": "The Pointe Of Ridgeland",
  "property_website_url": "https://www.caseusa.com/apartments/ms/ridgeland/the-pointe-of-ridgeland/",
  "property_domain": null,
  "property_address": "831 Rice Road",
  "property_full_address": "831 Rice Road, Ridgeland, MS, 39157",
  "property_address_1": "831 Rice Road",
  "property_address_2": null,
  "property_address_city": "Ridgeland",
  "property_address_state": "MS",
  "property_address_zip_full": null,
  "property_address_zip": "39157",
  "property_address_country": "US",
  "property_address_county": "Madison County",
  "property_neighborhood_address": null,
  "property_address_latitude": "32.419",
  "property_address_longitude": "-90.0989",
  "property_email": "thepointe@caseusa.com",
  "property_phone": "(601) 514-6634",
  "property_call_tracking_phone": "844-348-0861",
  "property_company_name": "Case & Associates",
  "property_company_url": "https://www.caseusa.com/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "At The Pointe of Ridgeland, your ideal home awaits in a vibrant community nestled in Ridgeland, MS. Choose from spacious one, two, or three-bedroom floor plans, complemented by amenities like a sparkling outdoor pool, a cozy BBQ area, and a fun bark park. Discover a lifestyle filled with comfort and convenience today! Prefer to explore on your own time? Self-guided tours are available.",
  "property_long_description": "Welcome to The Pointe of Ridgeland, where modern living meets convenient amenities in the heart of Ridgeland, MS. Our thoughtfully designed apartment community offers a variety of spacious floor plans, including one, two, and three-bedroom options to suit your lifestyle needs. Each apartment features desirable amenities such as air conditioning, plush carpeting, and private balconies or patios—perfect for enjoying your morning coffee or unwinding after a long day.\n\nExperience a vibrant community filled with top-notch amenities designed to enhance your everyday life. Take advantage of our outdoor swimming pool for relaxation on sunny days, or challenge friends to a match at our tennis or indoor racquetball courts. For those who enjoy the outdoors, we offer a scenic walking trail with a serene pond, ideal for your morning jog or evening stroll.\n\nStay productive in our business center or connect with your furry friend at our bark park. Need assistance? Our caring onsite management is here to accommodate your needs, from package receiving to 24-hour emergency maintenance. With flexible payment options and easy online rental payments, managing your living expenses is a breeze!\n\nLocated in close proximity to the reservoir, residents can enjoy an array of recreational activities just a stone's throw away. Discover why so many are choosing The Pointe of Ridgeland as their next home sweet home.   \n\nFind your new abode today—browse our availability or schedule a tour to visit our welcoming community! Let The Pointe of Ridgeland be your gateway to comfortable living in Ridgeland, MS.",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019cfb54-8031-73a9-a48e-965c6e21fb40.webp",
  "property_featured_image_media": {
    "alt_text": "Exterior view of apartment buildings with blooming trees and stone accents.",
    "public_id": "019cfb54-8031-73a9-a48e-965c6e21fb40",
    "storage_key": "property/6767906449167046/019cfb54-8031-73a9-a48e-965c6e21fb40.webp",
    "width": 1536,
    "height": 1147
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": null,
  "property_year_built": null,
  "property_year_renovated": null,
  "property_walk_score": "24",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": null,
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "500",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Cats & Dogs",
  "property_pet_policy_description": "Cats & Dogs",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://pointeapartmentsridgeland.securecafe.com/onlineleasing/the-pointe-of-ridgeland/floorplans.aspx",
  "property_resident_portal_url": "https://pointeapartmentsridgeland.securecafe.com/residentservices/the-pointe-of-ridgeland/userlogin.aspx",
  "property_apply_now_url": "https://pointeapartmentsridgeland.securecafe.com/onlineleasing/the-pointe-of-ridgeland/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019cfb53-d267-702f-b733-a81e38b3da78.webp",
  "property_primary_logo_media": {
    "alt_text": "The Pointe of Ridgeland logo",
    "public_id": "019cfb53-d267-702f-b733-a81e38b3da78",
    "storage_key": "property/6767906449167046/019cfb53-d267-702f-b733-a81e38b3da78.webp",
    "width": 1661,
    "height": 504
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019cfb54-cc67-7675-a89a-43d08812dc56.webp",
  "property_mono_white_logo_media": {
    "alt_text": "The Pointe of Ridgeland logo",
    "public_id": "019cfb54-cc67-7675-a89a-43d08812dc56",
    "storage_key": "property/6767906449167046/019cfb54-cc67-7675-a89a-43d08812dc56.webp",
    "width": 640,
    "height": 194
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019cfb54-d411-747b-a952-febc28437812.webp",
  "property_mono_black_logo_media": {
    "alt_text": "The Pointe of Ridgeland logo",
    "public_id": "019cfb54-d411-747b-a952-febc28437812",
    "storage_key": "property/6767906449167046/019cfb54-d411-747b-a952-febc28437812.webp",
    "width": 640,
    "height": 194
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
  "property_company_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb35-ce4c-7138-92b0-dd454c056e38",
    "storage_key": "company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
    "width": 640,
    "height": 256
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#556771",
  "property_secondary_color": "#3d3d3f",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#c4beb2",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "650 - 1350",
  "property_sqft_min": "650",
  "property_sqft_max": "1350",
  "property_price_range": "1199 - 1819",
  "property_price_min": "1199",
  "property_price_max": "1819",
  "property_available_units": 9,
  "property_facebook_url": "https://www.facebook.com/PointeofRidgeland/posts/bright-welcoming-and-easy-to-loveour-living-spaces-at-the-pointe-of-ridgeland-ar/1692502035377964/",
  "property_instagram_url": "https://www.instagram.com/thepointeofridgeland/?hl=en",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJiSRiHbnTKYYRR7x0mZ_3PDk",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/the-trace-of-ridgeland-ridgeland-2",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to The Pointe of Ridgeland",
  "property_home_romance_title": "Embrace the Joy of Living in Your New Home",
  "property_home_amenities_blurb": "Welcome to The Pointe of Ridgeland, where comfort meets convenience in the heart of Ridgeland, MS. Choose from our thoughtfully designed one, two, or three-bedroom apartments, complete with modern amenities like a 24-hour fitness center, scenic walking trails, and a refreshing outdoor swimming pool. Your ideal lifestyle awaits!",
  "property_home_floorplans_blurb": "Welcome to The Pointe of Ridgeland, where modern living meets Southern charm. Nestled in the heart of Ridgeland, MS, our diverse floor plans cater to every lifestyle. Dive into comfort and style—browse our available apartments today to find the perfect space that feels just like home.",
  "property_home_gallery_blurb": "At The Pointe of Ridgeland, modern comfort meets vibrant lifestyle in a picturesque setting. Enjoy amenities like our refreshing outdoor pool, scenic walking trails, and a lively bark park. With spacious floor plans and caring onsite management, your ideal home awaits. Picture yourself living here in scenic Ridgeland, MS!",
  "property_home_neighborhood_blurb": "Nestled in the heart of Ridgeland, The Pointe of Ridgeland offers spacious one, two, and three-bedroom apartments surrounded by vibrant community life. Enjoy local gems like Freedom Ridge and Urban Air Trampoline Park, or unwind at the nearby Madison Healthplex. Embrace a lifestyle where convenience and recreation come together!",
  "property_home_reviews_blurb": "At The Pointe of Ridgeland, residents rave about the vibrant atmosphere, with one stating, “It feels like home the moment you walk in.” Nestled in the heart of Ridgeland, our community balances comfort and lifestyle. Curious about the experience? See what our residents have to say about living at our community!",
  "property_neighborhood_blurb": "At The Pointe of Ridgeland, life isn't just about your apartment—it's an adventure. Nestled in vibrant Ridgeland, you’re minutes from urban escapes like Urban Air Trampoline Park and serene parks like Freedom Ridge and Flowood Nature Park. See what surrounds your future home and embrace community favorites!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At The Pointe of Ridgeland, each day unfolds with convenience and comfort. Enjoy our outdoor swimming pool, relax at the BBQ area, or play a game on the tennis court. With spacious floor plans and modern features, your ideal lifestyle awaits. Connect with nature on scenic walking trails today!",
  "property_applynow_blurb": "At The Pointe of Ridgeland, your perfect home awaits in charming Ridgeland, MS. Choose from spacious one, two, or three-bedroom floor plans, each featuring modern amenities and cozy touches. Enjoy a vibrant community with a 24-hour fitness center, scenic trails, and a bark park—all designed for your ultimate comfort.",
  "property_contactus_blurb": "At The Pointe of Ridgeland, located in the heart of Ridgeland, MS, we offer thoughtfully designed one, two, and three-bedroom apartments that cater to your lifestyle. Each space whispers comfort and modern convenience. Have questions? Contact our leasing team today to find your perfect home!",
  "property_faqs_blurb": "At The Pointe of Ridgeland, we offer a variety of thoughtfully designed floor plans – from cozy one-bedrooms to spacious three-bedrooms – perfect for every lifestyle. Curious about our vibrant community? Dive into our FAQs to find answers about your future home in Ridgeland, MS. Your ideal apartment awaits!",
  "property_floorplans_blurb": "At The Pointe of Ridgeland, our diverse floor plans cater to every lifestyle. Choose from cozy one-bedroom retreats, spacious two-bedroom homes, or expansive three-bedroom layouts, all designed for comfort and style. Browse our available apartment homes today and find the perfect space to call your own in beautiful Ridgeland, MS.",
  "property_gallery_blurb": "At The Pointe of Ridgeland, vibrant living awaits with spacious one, two, and three-bedroom floor plans. Enjoy a sun-soaked day by the outdoor swimming pool, or unwind at the scenic pond. With amenities like a 24-hour fitness center and a bark park, picture your perfect life here!",
  "property_interactivemap_blurb": "At The Pointe of Ridgeland, each thoughtfully designed floor plan invites comfort and style, from cozy one-bedrooms to spacious three-bedrooms. Enjoy a vibrant lifestyle with amenities like our outdoor pool, bark park, and scenic walking trails. Use our interactive community map to find your perfect home in Ridgeland today!",
  "property_pets_blurb": "At The Pointe of Ridgeland, your ideal home awaits in the heart of Ridgeland, MS. Embrace a vibrant lifestyle with spacious apartments designed for both relaxation and connection. Bring your furry companions along – our pet-friendly community welcomes cats and dogs to share your journey in this charming oasis.",
  "property_referafriend_blurb": "At The Pointe of Ridgeland, spacious one, two, and three-bedroom floor plans await you and your friends. Share the joy of comfortable living in our vibrant community. Refer a friend today and elevate your neighborhood spirit—because great friends make the best neighbors! Join us in Ridgeland, MS!",
  "property_residentaccess_blurb": "Welcome to The Pointe of Ridgeland, where your ideal home awaits! Choose from spacious one, two, or three-bedroom floor plans tailored for modern living. Elevate your living experience by accessing your resident portal—conveniently pay rent, schedule maintenance, and more, all at your fingertips. Join our vibrant community today!",
  "property_reviews_blurb": "At The Pointe of Ridgeland in Ridgeland, MS, residents rave about their experience, stating, \"The staff is friendly and always willing to help!\" Immerse yourself in a vibrant community where comfort and convenience meet. See what our residents have to say about living at our community!",
  "property_created_at": "1770685155796",
  "property_scheduletour_blurb": "At The Pointe of Ridgeland, your ideal home awaits! Choose from our thoughtfully designed one, two, and three-bedroom floor plans, all crafted for comfort. Ready to envision your new lifestyle? Schedule a tour today, and hear firsthand what makes our community truly special!",
  "property_thankyou_blurb": "Thank you for reaching out to The Pointe of Ridgeland! With spacious one, two, and three-bedroom floor plans tailored for modern living, your future home awaits in the heart of Ridgeland, MS. Our team will connect with you soon to help you take the next exciting step!",
  "property_virtualtours_blurb": "At The Pointe of Ridgeland, our thoughtfully designed one, two, and three-bedroom apartments invite you to find your perfect home. Nestled in the heart of Ridgeland, MS, each floor plan boasts spacious living and modern amenities. Take a virtual tour today and step into your future!",
  "property_copyright": "2026 All Rights Reserved. The Pointe of Ridgeland",
  "property_seo_title_home": "The Pointe of Ridgeland |  Apartments in Ridgeland, MS",
  "property_seo_description_home": "Welcome to The Pointe of Ridgeland! Enjoy spacious floor plans, top-notch amenities, and a scenic environment. Your ideal home awaits in Ridgeland, MS!",
  "property_seo_title_floorplans": "Floor Plans | Ridgeland, MS Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal home at The Pointe of Ridgeland! Choose from cozy one, spacious two, or stylish three-bedroom layouts. Browse our floor plans today!",
  "property_seo_title_amenities": "Amenities | Ridgeland, MS Apartments for Rent",
  "property_seo_description_amenities": "Unwind at The Pointe of Ridgeland! Enjoy spacious apartments, a sparkling pool, fitness center, scenic trails, and pet-friendly spaces. Your oasis awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Ridgeland, MS",
  "property_seo_description_gallery": "Experience life at The Pointe of Ridgeland! From spacious floor plans to a relaxing outdoor pool and scenic trails, your dream home awaits. Picture it now!",
  "property_seo_title_virtualtours": "Virtual Tours | The Pointe of Ridgeland Apartments",
  "property_seo_description_virtualtours": "Step inside The Pointe of Ridgeland! Take a virtual tour of our spacious one, two, and three-bedroom apartments and envision your new life in Ridgeland, MS.",
  "property_seo_title_interactivemap": "Interactive Map | The Pointe of Ridgeland Apartments",
  "property_seo_description_interactivemap": "Find your serene retreat at The Pointe of Ridgeland! Use our interactive map to explore spacious apartments & amenities like a pool, bark park, and more!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Ridgeland, MS",
  "property_seo_description_neighborhood": "Explore the charm of Ridgeland, MS! Discover local favorites and hidden gems with The Pointe of Ridgeland, your gateway to vibrant neighborhoods.",
  "property_seo_title_contact": "Contact Us | The Pointe of Ridgeland",
  "property_seo_description_contact": "Elevate your lifestyle at The Pointe of Ridgeland! Choose from cozy one- to spacious three-bedroom apartments. Contact our leasing team today!",
  "property_seo_title_faqs": "FAQs | Apartments in Ridgeland, MS",
  "property_seo_description_faqs": "Discover answers about The Pointe of Ridgeland's spacious apartments, amenities, and community perks in beautiful Ridgeland, MS!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Ridgeland, MS",
  "property_seo_description_reviews": "Join our vibrant community at The Pointe of Ridgeland! Hear resident stories and enjoy premier amenities in a beautiful setting.",
  "property_seo_title_applynow": "Apply Now | Apartments in Ridgeland, MS",
  "property_seo_description_applynow": "Experience luxury living at The Pointe of Ridgeland! Enjoy spacious floor plans, top-notch amenities, and scenic views. Your perfect home awaits—apply now!",
  "property_seo_title_residentaccess": "Resident Access | The Pointe of Ridgeland",
  "property_seo_description_residentaccess": "Unlock convenience at The Pointe of Ridgeland! Access your resident portal to effortlessly pay rent, schedule maintenance, and manage your home with ease.",
  "property_seo_title_referafriend": "Refer A Friend | The Pointe of Ridgeland",
  "property_seo_description_referafriend": "Refer a friend to The Pointe of Ridgeland! Share the joy of stylish living in Ridgeland, MS. Great friends make the best neighbors—join us today!",
  "property_seo_title_scheduletour": "Schedule a Tour | The Pointe of Ridgeland",
  "property_seo_description_scheduletour": "Experience the charm of The Pointe of Ridgeland. Schedule your tour today to see your future home in a vibrant community surrounded by natural beauty!",
  "property_seo_title_privacy": "Privacy Policy | The Pointe of Ridgeland",
  "property_seo_description_privacy": "Your privacy matters at The Pointe of Ridgeland. Learn how we protect your information and enjoy peace of mind in your new home. View our privacy policy today!",
  "property_seo_title_accessibility": "Website Accessibility | The Pointe of Ridgeland",
  "property_seo_description_accessibility": "At The Pointe of Ridgeland, we prioritize accessibility for all. Experience a community where everyone can thrive in comfort and style. Join us today!",
  "property_seo_title_sitemap": "Sitemap | The Pointe of Ridgeland",
  "property_seo_description_sitemap": "Navigate The Pointe of Ridgeland effortlessly! Our sitemap helps you find your perfect home in Ridgeland, MS. Uncover your ideal living experience today!",
  "property_seo_title_thankyou": "Thank You | The Pointe of Ridgeland",
  "property_seo_description_thankyou": "Thank you for your inquiry at The Pointe of Ridgeland! We’ll be in touch soon to help you find your perfect home in vibrant Ridgeland, MS.",
  "property_seo_title_pets": "Pet Policy | Apartments in Ridgeland, MS",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787865966640",
  "amenities": [
    {
      "id": "ec_2ecc5fcc6e1c75899a8e0660",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "yardi",
      "external_id": "127397300",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ee4e77efcfddb3eb511d38c2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "yardi",
      "external_id": "127397301",
      "title": "Short Term Lease",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8f52bd4628db18eb09f06809",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "yardi",
      "external_id": "127397303",
      "title": "Outdoor Swimming Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c7e109fdf59bd3222e8d8873",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "yardi",
      "external_id": "127397304",
      "title": "Onsite Laundry Facility",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_54defe9bb82a3a70324c571b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "yardi",
      "external_id": "127397305",
      "title": "Tennis Court",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_33ecdcb1562e492812b0203f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "yardi",
      "external_id": "127397306",
      "title": "BBQ/Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f811b5fbb1161727cfdc7cee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "yardi",
      "external_id": "127397307",
      "title": "Indoor Racquetball Court",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ce15487f2aa29d044a8a68a9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "yardi",
      "external_id": "127397308",
      "title": "24-Hour Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_471b6f2ade3203396509ddb6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "yardi",
      "external_id": "127397309",
      "title": "24-Hour Emergency Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_859a209ced7bf9f51ff0ad75",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "yardi",
      "external_id": "127397310",
      "title": "Caring Onsite Management with Package Receiving",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_acefd6f5fa070c38036a3523",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "yardi",
      "external_id": "127397311",
      "title": "Scenic Walking Trail with Pond",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6bf9d52b7e593d2315d52024",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "yardi",
      "external_id": "127397312",
      "title": "flex. Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dbf8e1ece6fbac08d460637a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "yardi",
      "external_id": "127397313",
      "title": "Online Rental Payments",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_811eb2f9bfe0ae5c8eeb76c5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "yardi",
      "external_id": "128050916",
      "title": "AT&T",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c02157f249ccd4e2abc53822",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "yardi",
      "external_id": "127397314",
      "title": "Close Proximity to Reservoir",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b9a5adeb8ce493810a1ba58c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "yardi",
      "external_id": "127398762",
      "title": "Refrigerator",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d3922d9e7bb8d046d4b3a3ec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "yardi",
      "external_id": "127398763",
      "title": "Window Coverings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_10e9f3e00ea6fe50062a5893",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "yardi",
      "external_id": "127398764",
      "title": "Air Conditioner",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2a6ddd6cf604c5591aebc146",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "yardi",
      "external_id": "127398765",
      "title": "Carpeting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a71b5e496dcfb377c413de93",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "yardi",
      "external_id": "127398766",
      "title": "Washer/Dryer Connections",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c764a446f0c348f6b02176c8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "yardi",
      "external_id": "127398767",
      "title": "Private Patio or Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9d777b1dda34035f35d65c2f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "yardi",
      "external_id": "127398768",
      "title": "Wood-Burning Fireplace*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a224d00327b8fe0a19605897",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "yardi",
      "external_id": "127398769",
      "title": "Spacious Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_673f83d878e6846addeb8054",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "yardi",
      "external_id": "127398770",
      "title": "Ceiling Fan",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1d0fac511c707d64654cb699",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "yardi",
      "external_id": "127398771",
      "title": "Get Connected To Super-Fast Internet Powered by AT&T",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_80381761372724335f7dc2b8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "yardi",
      "external_id": "127398772",
      "title": "Spacious Kitchen with Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6dedb6004e7a5f770684ef73",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "yardi",
      "external_id": "127398773",
      "title": "Storage Rooms*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_2dd2af3b-ba1b-4853-8217-fbf7a867502c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d20b9-c3f7-73cd-b6a9-30a43f675e25.webp",
      "image_media": {
        "alt_text": "Exterior sign for The Pointe of Ridgeland apartment community surrounded by trees and landscaping.",
        "public_id": "019d20b9-c3f7-73cd-b6a9-30a43f675e25",
        "storage_key": "property/6767906449167046/019d20b9-c3f7-73cd-b6a9-30a43f675e25.webp",
        "width": 1600,
        "height": 1280
      },
      "title": "Community",
      "description": "Exterior view of The Pointe of Ridgeland community sign amid landscaped grounds.",
      "link": "",
      "alt_text": "Exterior sign for The Pointe of Ridgeland apartment community surrounded by trees and landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167046/019cfb53-b933-71ee-ab14-ce7c451c5b9b.webp"
    },
    {
      "id": "custom_f33d4588-870c-4173-9824-bf498da86a82",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d20b9-c471-77ef-976b-1b7801b5815e.webp",
      "image_media": {
        "alt_text": "Outdoor playground in a wooded area with a red tunnel play structure and trees.",
        "public_id": "019d20b9-c471-77ef-976b-1b7801b5815e",
        "storage_key": "property/6767906449167046/019d20b9-c471-77ef-976b-1b7801b5815e.webp",
        "width": 1600,
        "height": 1280
      },
      "title": "Community",
      "description": "Shaded outdoor playground in the community area, featuring a red tunnel structure and basic play equipment.",
      "link": "",
      "alt_text": "Outdoor playground in a wooded area with a red tunnel play structure and trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167046/019cfb53-b929-74e3-8591-75f424b064da.webp"
    },
    {
      "id": "custom_010fc1a7-3f91-4cd7-8027-61ed8ebb59d3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d20b9-c3e9-70d9-a1af-ebfd8d844416.webp",
      "image_media": {
        "alt_text": "Exterior view of blue multi-family apartments with balconies and pink flowering trees.",
        "public_id": "019d20b9-c3e9-70d9-a1af-ebfd8d844416",
        "storage_key": "property/6767906449167046/019d20b9-c3e9-70d9-a1af-ebfd8d844416.webp",
        "width": 1600,
        "height": 1280
      },
      "title": "Community",
      "description": "Exterior view of a blue apartment community with balconies, stone accents, and landscaped grounds.",
      "link": "",
      "alt_text": "Exterior view of blue multi-family apartments with balconies and pink flowering trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167046/019cfb53-b915-764e-a123-c919cc4f3c26.webp"
    },
    {
      "id": "custom_aa560e86-8399-412b-9c43-8aa45d446c56",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d20b9-c3fc-751b-9c5c-0ad70f1200de.webp",
      "image_media": {
        "alt_text": "Exterior view of a blue multi-unit apartment building with balconies and landscaping.",
        "public_id": "019d20b9-c3fc-751b-9c5c-0ad70f1200de",
        "storage_key": "property/6767906449167046/019d20b9-c3fc-751b-9c5c-0ad70f1200de.webp",
        "width": 1600,
        "height": 1280
      },
      "title": "Community",
      "description": "Blue three-story apartment building with balconies and landscaped grounds.",
      "link": "",
      "alt_text": "Exterior view of a blue multi-unit apartment building with balconies and landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167046/019cfb53-b920-73cb-a894-222b27235ca8.webp"
    },
    {
      "id": "custom_78492c36-6644-44c2-a32c-b19a8019a633",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d20b9-cedf-73d9-b315-27ec734a8d53.webp",
      "image_media": {
        "alt_text": "Exterior of a small apartment building with gray siding, stone chimney, and landscaped front yard.",
        "public_id": "019d20b9-cedf-73d9-b315-27ec734a8d53",
        "storage_key": "property/6767906449167046/019d20b9-cedf-73d9-b315-27ec734a8d53.webp",
        "width": 1600,
        "height": 1280
      },
      "title": "Community",
      "description": "A quaint apartment building exterior with a stone chimney and well-kept landscaping.",
      "link": "",
      "alt_text": "Exterior of a small apartment building with gray siding, stone chimney, and landscaped front yard.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167046/019cfb53-ba9a-750f-9bee-c772e5152639.webp"
    },
    {
      "id": "custom_850be187-0d32-47af-9bb5-b0f4bcd6f2d4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d20b9-cf96-7572-aba3-8cf3957000da.webp",
      "image_media": {
        "alt_text": "Outdoor community pool with blue lounge chairs on a brick deck beside a building.",
        "public_id": "019d20b9-cf96-7572-aba3-8cf3957000da",
        "storage_key": "property/6767906449167046/019d20b9-cf96-7572-aba3-8cf3957000da.webp",
        "width": 1280,
        "height": 1024
      },
      "title": "Community",
      "description": "Outdoor pool area at a multifamily community, featuring a curved pool, brick patio, and blue lounge chairs.",
      "link": "",
      "alt_text": "Outdoor community pool with blue lounge chairs on a brick deck beside a building.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019cfb53-745d-76bf-8ae3-345c0d9eff9e.webp"
    },
    {
      "id": "custom_f6d3f9c0-4e48-455b-9663-664081e2da67",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d20b9-d8dc-730b-a95a-aeabe5b23edf.webp",
      "image_media": {
        "alt_text": "Interior common lounge with beige sofa, fireplace, large TV, and workstation desks.",
        "public_id": "019d20b9-d8dc-730b-a95a-aeabe5b23edf",
        "storage_key": "property/6767906449167046/019d20b9-d8dc-730b-a95a-aeabe5b23edf.webp",
        "width": 1280,
        "height": 1024
      },
      "title": "Community",
      "description": "Spacious resident lounge with seating, a fireplace, a wall-mounted TV, and desk workstations.",
      "link": "",
      "alt_text": "Interior common lounge with beige sofa, fireplace, large TV, and workstation desks.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019cfb53-7659-751d-bf07-5ecb60006444.webp"
    },
    {
      "id": "custom_6b0cd2f3-79ec-4142-bd52-346845cf7694",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d20b9-dedb-723e-9d52-9af1f204882d.webp",
      "image_media": {
        "alt_text": "Interior communal lounge with beige sofa, desks, a wall-mounted TV, ceiling fans, and exposed ducts.",
        "public_id": "019d20b9-dedb-723e-9d52-9af1f204882d",
        "storage_key": "property/6767906449167046/019d20b9-dedb-723e-9d52-9af1f204882d.webp",
        "width": 1280,
        "height": 1024
      },
      "title": "Community",
      "description": "Spacious community lounge with seating, work desks, and a wall-mounted TV in a modern, industrial-style clubhouse.",
      "link": "",
      "alt_text": "Interior communal lounge with beige sofa, desks, a wall-mounted TV, ceiling fans, and exposed ducts.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019cfb53-794e-77dc-987b-b69ded91b2f1.webp"
    },
    {
      "id": "custom_1a8b7ef7-dde7-4a11-92a0-bea3b1083310",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d20b9-e239-7201-8de3-a257b25e7949.webp",
      "image_media": {
        "alt_text": "Bright resident lounge with white sectional sofa, fireplace, and desks by large windows.",
        "public_id": "019d20b9-e239-7201-8de3-a257b25e7949",
        "storage_key": "property/6767906449167046/019d20b9-e239-7201-8de3-a257b25e7949.webp",
        "width": 1600,
        "height": 1280
      },
      "title": "Community",
      "description": "Bright communal lounge in a multifamily community with a mounted TV, fireplace, and coworking-style desks.",
      "link": "",
      "alt_text": "Bright resident lounge with white sectional sofa, fireplace, and desks by large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167046/019cfb53-baed-76e9-90eb-334131855f60.webp"
    },
    {
      "id": "custom_f29863fe-fb48-4471-88e5-4e9ae908c7bc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d20b9-ec85-7089-aca2-9f2884841d8a.webp",
      "image_media": {
        "alt_text": "Bathroom with sink, mirror, toilet, and shower in an apartment unit.",
        "public_id": "019d20b9-ec85-7089-aca2-9f2884841d8a",
        "storage_key": "property/6767906449167046/019d20b9-ec85-7089-aca2-9f2884841d8a.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Interior bathroom in a multifamily apartment with a granite countertop vanity, toilet, shower, and decorative wall art.",
      "link": "",
      "alt_text": "Bathroom with sink, mirror, toilet, and shower in an apartment unit.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019cfb53-6016-70f9-9b18-733b70208bd7.webp"
    },
    {
      "id": "custom_39c79435-35dc-43ac-ad1f-2aa7f5f32434",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d20b9-ee79-773b-b7b7-6dbe9a04493e.webp",
      "image_media": {
        "alt_text": "Galley-style apartment kitchen with wooden cabinets, beige countertops, double sink, and white appliances.",
        "public_id": "019d20b9-ee79-773b-b7b7-6dbe9a04493e",
        "storage_key": "property/6767906449167046/019d20b9-ee79-773b-b7b7-6dbe9a04493e.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Compact apartment kitchen with wood cabinets, beige countertops, a double sink, and white stove/oven.",
      "link": "",
      "alt_text": "Galley-style apartment kitchen with wooden cabinets, beige countertops, double sink, and white appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019cfb53-603c-753c-a679-2ee11747fbed.webp"
    },
    {
      "id": "custom_66e51bc1-c6db-41a7-b8e0-fce7fe89b5fc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d20b9-ef3c-720f-b0d8-d3142229b53a.webp",
      "image_media": {
        "alt_text": "L-shaped kitchen with oak cabinets, white electric range, and sink.",
        "public_id": "019d20b9-ef3c-720f-b0d8-d3142229b53a",
        "storage_key": "property/6767906449167046/019d20b9-ef3c-720f-b0d8-d3142229b53a.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bright apartment kitchen with abundant oak cabinets, a white electric range, dishwasher, and a sink along a countertop.",
      "link": "",
      "alt_text": "L-shaped kitchen with oak cabinets, white electric range, and sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019cfb53-6091-73df-9765-8ee249da0fab.webp"
    },
    {
      "id": "custom_042c47c7-6284-4738-be9c-94caf1c733b6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d20b9-f1d5-77cb-a380-53382a3852a8.webp",
      "image_media": {
        "alt_text": "Bedroom with a gray upholstered bed, nightstand, and a large window with blinds.",
        "public_id": "019d20b9-f1d5-77cb-a380-53382a3852a8",
        "storage_key": "property/6767906449167046/019d20b9-f1d5-77cb-a380-53382a3852a8.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Cozy apartment bedroom with neutral tones, plush bed, and a sunny window seating area.",
      "link": "",
      "alt_text": "Bedroom with a gray upholstered bed, nightstand, and a large window with blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019cfb53-7a74-76d9-9657-ff5c487a6093.webp"
    },
    {
      "id": "custom_da7d065f-66b8-437a-80ea-6673b9b29a1f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d20b9-f887-705b-9392-73e5c6a62af5.webp",
      "image_media": {
        "alt_text": "Open living area with kitchen pass-through, sofa, and built-in shelves in a white-walled apartment.",
        "public_id": "019d20b9-f887-705b-9392-73e5c6a62af5",
        "storage_key": "property/6767906449167046/019d20b9-f887-705b-9392-73e5c6a62af5.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Cozy living area with an open kitchen pass-through and built-in shelves, highlighting a bright, simple apartment layout.",
      "link": "",
      "alt_text": "Open living area with kitchen pass-through, sofa, and built-in shelves in a white-walled apartment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019cfb53-6c12-739a-a7bd-6d9c1c938bd3.webp"
    },
    {
      "id": "custom_eb4f0c56-4321-4345-a494-af12ac1f985c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d20b9-fa88-715a-a5d6-13ae0c4213bc.webp",
      "image_media": {
        "alt_text": "Bright living room with a beige sectional sofa, wall mirrors, TV, and a dining table.",
        "public_id": "019d20b9-fa88-715a-a5d6-13ae0c4213bc",
        "storage_key": "property/6767906449167046/019d20b9-fa88-715a-a5d6-13ae0c4213bc.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Spacious, modern apartment living room with wall mirrors, a TV nook, and a dining area.",
      "link": "",
      "alt_text": "Bright living room with a beige sectional sofa, wall mirrors, TV, and a dining table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019cfb53-5fec-72fc-ad6d-9a03fa8eb96c.webp"
    },
    {
      "id": "custom_843fca56-ea1f-46b7-8b29-adf1f1ab2a80",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d20b9-fb26-75b9-965c-7ec9ca8a4c45.webp",
      "image_media": {
        "alt_text": "Bathroom in an apartment with a granite counter, sink, toilet, and a tub/shower with white tiles.",
        "public_id": "019d20b9-fb26-75b9-965c-7ec9ca8a4c45",
        "storage_key": "property/6767906449167046/019d20b9-fb26-75b9-965c-7ec9ca8a4c45.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bright apartment bathroom featuring a granite vanity, sink, toilet, and a white-tiled tub/shower.",
      "link": "",
      "alt_text": "Bathroom in an apartment with a granite counter, sink, toilet, and a tub/shower with white tiles.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019cfb53-6026-7102-a22b-92e3d3c83a61.webp"
    },
    {
      "id": "custom_6d37f132-299a-4d5e-a852-0bed8d7b42db",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d20b9-fb53-738a-9e72-cd1864eb275b.webp",
      "image_media": {
        "alt_text": "Bedroom with a dark wood bed frame, dresser, ceiling fan, and a window with sheer curtains.",
        "public_id": "019d20b9-fb53-738a-9e72-cd1864eb275b",
        "storage_key": "property/6767906449167046/019d20b9-fb53-738a-9e72-cd1864eb275b.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Cozy apartment bedroom with white walls, a dark wood bed frame, dresser, ceiling fan, and a large window for natural light.",
      "link": "",
      "alt_text": "Bedroom with a dark wood bed frame, dresser, ceiling fan, and a window with sheer curtains.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019cfb53-6357-72a3-a293-0982b5b09e99.webp"
    },
    {
      "id": "custom_a9c84f08-dc4a-401c-975a-7a210e99ca43",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d20ba-033b-74bf-95ad-9a80d271ec1f.webp",
      "image_media": {
        "alt_text": "Walk-in closet with white walls, dual clothes rods along two walls, and beige carpet.",
        "public_id": "019d20ba-033b-74bf-95ad-9a80d271ec1f",
        "storage_key": "property/6767906449167046/019d20ba-033b-74bf-95ad-9a80d271ec1f.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Interior shot of an apartment walk-in closet with multiple hanging rods and neutral finishes.",
      "link": "",
      "alt_text": "Walk-in closet with white walls, dual clothes rods along two walls, and beige carpet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019cfb53-6065-724e-819e-3e590cf8e7b3.webp"
    },
    {
      "id": "custom_e985f6b7-666f-4a16-a398-f43542301fbd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d20ba-0499-7251-aaf8-da6212d5d2d9.webp",
      "image_media": {
        "alt_text": "Bedroom with dark wood bed, dresser, and nightstands, white bedding.",
        "public_id": "019d20ba-0499-7251-aaf8-da6212d5d2d9",
        "storage_key": "property/6767906449167046/019d20ba-0499-7251-aaf8-da6212d5d2d9.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Furnished apartment bedroom featuring a dark wood bed with matching dresser and nightstands, neutral decor.",
      "link": "",
      "alt_text": "Bedroom with dark wood bed, dresser, and nightstands, white bedding.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019cfb53-634f-71fb-a84b-e9613b6ff69d.webp"
    },
    {
      "id": "custom_42884b3b-a917-466b-852f-f0487998b006",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d20ba-04fe-777b-8227-2b5e16510298.webp",
      "image_media": {
        "alt_text": "Cozy apartment living room with a green sofa, white armchair, two round ottomans, wall-mounted TV, and sheer-curtained window.",
        "public_id": "019d20ba-04fe-777b-8227-2b5e16510298",
        "storage_key": "property/6767906449167046/019d20ba-04fe-777b-8227-2b5e16510298.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bright, modern living room in a multifamily unit with a green sofa, white lounge chair, and ottomans, plus a recessed TV and natural light.",
      "link": "",
      "alt_text": "Cozy apartment living room with a green sofa, white armchair, two round ottomans, wall-mounted TV, and sheer-curtained window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019cfb53-6eaf-72cc-9b8b-922445f17d5f.webp"
    },
    {
      "id": "custom_1866d820-0f94-48a9-8c26-0d23cb421dfa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d20ba-0f61-7019-98b0-40853bb0d368.webp",
      "image_media": {
        "alt_text": "Living room with a beige sectional sofa, coffee table, and open kitchen pass-through.",
        "public_id": "019d20ba-0f61-7019-98b0-40853bb0d368",
        "storage_key": "property/6767906449167046/019d20ba-0f61-7019-98b0-40853bb0d368.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bright living area in a modern apartment with a light sofa and open kitchen overlook.",
      "link": "",
      "alt_text": "Living room with a beige sectional sofa, coffee table, and open kitchen pass-through.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019cfb53-6e5d-753d-a2f0-ab3e4c99d9ae.webp"
    },
    {
      "id": "custom_e4cada76-d393-4413-a34a-e0a852185ddd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d20ba-1491-76ae-bb3f-303fc5833879.webp",
      "image_media": {
        "alt_text": "Apartment bathroom with a white tile shower, tub, toilet, and vanity.",
        "public_id": "019d20ba-1491-76ae-bb3f-303fc5833879",
        "storage_key": "property/6767906449167046/019d20ba-1491-76ae-bb3f-303fc5833879.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bright, modern apartment bathroom featuring a tub/shower, sink vanity, and decorative wall art.",
      "link": "",
      "alt_text": "Apartment bathroom with a white tile shower, tub, toilet, and vanity.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019cfb53-7073-7478-a947-30ffcec5ddd1.webp"
    },
    {
      "id": "custom_55e2f553-cbae-43f9-aef6-db4058365147",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d20ba-1d62-74ac-bd1b-966e8dbf5c03.webp",
      "image_media": {
        "alt_text": "Walk-in closet with white walls and metal clothing rods, opening to a small bathroom.",
        "public_id": "019d20ba-1d62-74ac-bd1b-966e8dbf5c03",
        "storage_key": "property/6767906449167046/019d20ba-1d62-74ac-bd1b-966e8dbf5c03.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Interior shot of a walk-in closet adjoining a small bathroom, highlighting built-in wardrobe rods and a bright, clean design.",
      "link": "",
      "alt_text": "Walk-in closet with white walls and metal clothing rods, opening to a small bathroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019cfb53-71e8-74aa-897b-107f541b282a.webp"
    },
    {
      "id": "custom_4189baf6-d8cd-44ed-83c6-7bc777e6f766",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d20ba-1f11-71ab-b989-b0327cdad7dd.webp",
      "image_media": {
        "alt_text": "Cozy living room with olive sofa, white armchair, mounted TV, and large windows with curtains.",
        "public_id": "019d20ba-1f11-71ab-b989-b0327cdad7dd",
        "storage_key": "property/6767906449167046/019d20ba-1f11-71ab-b989-b0327cdad7dd.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Bright apartment living room with modern seating and a mounted TV, filled with natural light.",
      "link": "",
      "alt_text": "Cozy living room with olive sofa, white armchair, mounted TV, and large windows with curtains.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167046/019cfb53-c47e-72bb-b3b5-d169e4193d8c.webp"
    },
    {
      "id": "custom_b1db0b52-055a-4e61-b403-e1334b7aca32",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d20ba-20eb-729d-9932-6a92013cb1f2.webp",
      "image_media": {
        "alt_text": "Bright living room with beige sofa, wall art, TV alcove, and dining table.",
        "public_id": "019d20ba-20eb-729d-9932-6a92013cb1f2",
        "storage_key": "property/6767906449167046/019d20ba-20eb-729d-9932-6a92013cb1f2.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Bright living space in a contemporary apartment featuring a beige sofa, wall decor, a TV alcove, and a dining table.",
      "link": "",
      "alt_text": "Bright living room with beige sofa, wall art, TV alcove, and dining table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167046/019cfb53-d119-7607-ab3d-330c1977d9d9.webp"
    },
    {
      "id": "custom_08b70327-1d86-4c55-bd50-8d4c61e4657b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d20ba-2a1d-7729-bf73-2fd00f6d4e16.webp",
      "image_media": {
        "alt_text": "Sunset over a river with a steel truss bridge and a tugboat pulling a barge, framed by trees.",
        "public_id": "019d20ba-2a1d-7729-bf73-2fd00f6d4e16",
        "storage_key": "property/6767906449167046/019d20ba-2a1d-7729-bf73-2fd00f6d4e16.webp",
        "width": 1586,
        "height": 594
      },
      "title": "Lifestyle",
      "description": "A scenic exterior shot of a river, steel truss bridge, and tugboat, conveying a waterfront, nature-forward vibe.",
      "link": "",
      "alt_text": "Sunset over a river with a steel truss bridge and a tugboat pulling a barge, framed by trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167046/019cfb53-d3bf-7438-b18b-d8001bc63552.webp"
    },
    {
      "id": "custom_9f1381a9-a784-4f87-81b7-805af5b3c4e9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d20ba-2e5e-76a6-9dd6-39f6b32edb9c.webp",
      "image_media": {
        "alt_text": "Children with backpacks queue to board a yellow school bus.",
        "public_id": "019d20ba-2e5e-76a6-9dd6-39f6b32edb9c",
        "storage_key": "property/6767906449167046/019d20ba-2e5e-76a6-9dd6-39f6b32edb9c.webp",
        "width": 788,
        "height": 663
      },
      "title": "Lifestyle",
      "description": "Kids with backpacks line up to board a yellow school bus, ready for school.",
      "link": "",
      "alt_text": "Children with backpacks queue to board a yellow school bus.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167046/019cfb53-d3c7-73aa-bffc-4dcec13b8fe3.webp"
    },
    {
      "id": "custom_2fe89041-f2a0-4bb4-9dec-468129b192ab",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d20ba-3591-7294-bdeb-1d0f3d54a275.webp",
      "image_media": {
        "alt_text": "Person holding a white travel mug beside a bicycle outdoors.",
        "public_id": "019d20ba-3591-7294-bdeb-1d0f3d54a275",
        "storage_key": "property/6767906449167046/019d20ba-3591-7294-bdeb-1d0f3d54a275.webp",
        "width": 698,
        "height": 797
      },
      "title": "Lifestyle",
      "description": "Lifestyle image of a resident with a travel mug beside a bicycle, highlighting an active outdoor community.",
      "link": "",
      "alt_text": "Person holding a white travel mug beside a bicycle outdoors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449167046/019cfb53-d3c9-76a8-9547-20e2156c84c5.webp"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_f976e498-527f-40df-8715-3bb99ded9415",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "custom",
      "poi_name": "Mama Hamil's Southern Cookin' and Bar B Que Buffet",
      "poi_type": "Restaurants",
      "poi_address": "480 Magnolia St, Madison, MS 39110, USA",
      "poi_short_description": "Big, buffet-style joint for Southern home cooking & BBQ with wood booths & communal tables.",
      "poi_long_description": "People say this barbecue restaurant serves delicious Southern dishes, including fried chicken, ribs, and catfish, as well as a wide variety of vegetables and desserts like peach cobbler and bread pudding. They highlight the generous portions, reasonable prices, and the home-cooked, soul food experience. They also like the friendly and attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d270e-1fcd-7327-acc9-1fd51737b60b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-1fcd-7327-acc9-1fd51737b60b",
        "storage_key": "property/6767906449167046/019d270e-1fcd-7327-acc9-1fd51737b60b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.hamils.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11010288085330032935&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mama-hamils-southern-cookin-and-bar-b-que-buffet",
      "poi_latitude": "32.4448008",
      "poi_longitude": "-90.1230138",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 601-856-4407",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d270e-5137-73fe-8ee3-feedecdad4e7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-5137-73fe-8ee3-feedecdad4e7",
        "storage_key": "property/6767906449167046/019d270e-5137-73fe-8ee3-feedecdad4e7.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJo3jiACfSKYYRJ_nPuK1mzJg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_b3c7f4ff-dfba-49e7-a3ed-9907a642f047",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "custom",
      "poi_name": "Shaggy's on the Rez",
      "poi_type": "Restaurants",
      "poi_address": "1733 Spillway Rd, Brandon, MS 39047, USA",
      "poi_short_description": "Popular, lively restaurant and bar serving seafood-inspired fare and featuring outdoor seating with reservoir views.",
      "poi_long_description": "People say this restaurant serves delicious seafood, including oysters, shrimp, and redfish, and offers generous portions. They highlight the fun, laid-back atmosphere, the beautiful waterfront views, and the live music. They also like the friendly, attentive, and accommodating service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d270e-2000-767a-a890-c31b3c6d8b89.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-2000-767a-a890-c31b3c6d8b89",
        "storage_key": "property/6767906449167046/019d270e-2000-767a-a890-c31b3c6d8b89.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://shaggys.com/locations/on-the-rez/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12606896511369096172&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "shaggys-on-the-rez",
      "poi_latitude": "32.3882456",
      "poi_longitude": "-90.04912420000001",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 601-724-2990",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d270e-5137-73fe-8ee3-feedecdad4e7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-5137-73fe-8ee3-feedecdad4e7",
        "storage_key": "property/6767906449167046/019d270e-5137-73fe-8ee3-feedecdad4e7.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJycGXC-nVKYYR7CtEOJWx9K4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_edc2313a-c7c7-4db4-bf49-5588ad63d30a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "custom",
      "poi_name": "Raising Cane's Chicken Fingers",
      "poi_type": "Restaurants",
      "poi_address": "202 E Layfair Dr, Flowood, MS 39232, USA",
      "poi_short_description": "Fast-food chain specializing in fried chicken fingers, crinkle-cut fries & Texas toast.",
      "poi_long_description": "People say this fast food restaurant serves delicious chicken fingers, fries, and bread. They highlight the food is hot, fresh, and consistently great, and the service is fast and efficient. They also like the clean environment and friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d270e-1fcd-7327-acc9-194d7619de94.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-1fcd-7327-acc9-194d7619de94",
        "storage_key": "property/6767906449167046/019d270e-1fcd-7327-acc9-194d7619de94.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://locations.raisingcanes.com/ms/flowood/202-e.-layfair-dr",
      "poi_directions_map_url": "https://maps.google.com/?cid=119709276499798027&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "raising-canes-chicken-fingers",
      "poi_latitude": "32.3313599",
      "poi_longitude": "-90.1053988",
      "poi_miles_from_property": "10",
      "poi_walking_minutes": "3 hours 40 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 601-933-9713",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d270e-5137-73fe-8ee3-feedecdad4e7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-5137-73fe-8ee3-feedecdad4e7",
        "storage_key": "property/6767906449167046/019d270e-5137-73fe-8ee3-feedecdad4e7.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJHz4FBecsKIYRC-gW5vNKqQE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_59d0848c-544b-49a4-ac24-bb2b203cbab6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "1873 Main St, Madison, MS 39110, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_long_description": "Diners say this chicken restaurant offers delicious, juicy, and fresh chicken, and they praise the positive vibes and wonderful customer service. They also highlight the convenient locations, fast drive-through, and children's play space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d270e-1f66-77c9-af2c-e435ea5261de.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-1f66-77c9-af2c-e435ea5261de",
        "storage_key": "property/6767906449167046/019d270e-1f66-77c9-af2c-e435ea5261de.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/ms/madison-ms?utm_source=yext&utm_medium=link",
      "poi_directions_map_url": "https://maps.google.com/?cid=417678638787326989&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "32.46803",
      "poi_longitude": "-90.1307161",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 601-898-2338",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d270e-5137-73fe-8ee3-feedecdad4e7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-5137-73fe-8ee3-feedecdad4e7",
        "storage_key": "property/6767906449167046/019d270e-5137-73fe-8ee3-feedecdad4e7.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJc6QgS5XRKYYRDfQvT4LkywU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_39a3ea4f-ce1b-4f4a-b661-3b9bf8a47082",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "custom",
      "poi_name": "Walk-On's Sports Bistreaux - Ridgeland Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "720 Highland Colony Pkwy, Ridgeland, MS 39157, USA",
      "poi_short_description": "This game-day bar serves burgers & fried fare, plus local beers & party platters for big groups.",
      "poi_long_description": "Diners say this sports bar serves up delicious cheese sticks, gumbo, pasta, and a wide selection of drinks. They also highlight the friendly and attentive service, as well as the lively and fun atmosphere, making it a great spot for a casual meal or watching a game.\n\nSome reviews mention the noise level can be loud.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d270e-2404-7514-aae8-b4f519d6ccb7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-2404-7514-aae8-b4f519d6ccb7",
        "storage_key": "property/6767906449167046/019d270e-2404-7514-aae8-b4f519d6ccb7.webp",
        "width": 700,
        "height": 393
      },
      "poi_business_url": "https://locate.walk-ons.com/ms/ridgeland/restaurants-418.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=3366707697943520067&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "walk-ons-sports-bistreaux---ridgeland-restaurant",
      "poi_latitude": "32.424255",
      "poi_longitude": "-90.1486204",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 601-345-4747",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d270e-5137-73fe-8ee3-feedecdad4e7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-5137-73fe-8ee3-feedecdad4e7",
        "storage_key": "property/6767906449167046/019d270e-5137-73fe-8ee3-feedecdad4e7.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJjURAnVjTKYYRQyN_TtDyuC4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_522363d3-9632-4dbd-ae0d-05674f8b139a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "custom",
      "poi_name": "Northpark",
      "poi_type": "Shopping & Retail",
      "poi_address": "1200 E County Line Rd, Ridgeland, MS 39157, USA",
      "poi_short_description": "Clothing chain with trendy apparel, shoes & accessories for teen girls & young women.",
      "poi_long_description": "People say this shopping center offers a wide variety of stores and food options, including a popular popcorn shop. They also highlight the friendly atmosphere, helpful staff, and great deals.\n\nOther reviews mention some stores can be vacant.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d270e-2512-71a6-bf2c-f4497fecfdd2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-2512-71a6-bf2c-f4497fecfdd2",
        "storage_key": "property/6767906449167046/019d270e-2512-71a6-bf2c-f4497fecfdd2.webp",
        "width": 1280,
        "height": 819
      },
      "poi_business_url": "http://www.visitnorthpark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14074278564042696477&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "northpark",
      "poi_latitude": "32.4030556",
      "poi_longitude": "-90.1291667",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 601-863-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d270e-5157-77f3-962a-e6d251d35bfa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-5157-77f3-962a-e6d251d35bfa",
        "storage_key": "property/6767906449167046/019d270e-5157-77f3-962a-e6d251d35bfa.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJhY9vW4rSKYYRHeeoB8nhUcM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_5734d7c2-fd60-4951-974e-9536f1c545cb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "4500 I-55, Jackson, MS 39211, USA",
      "poi_short_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_long_description": "People say this grocery store offers a wide variety of fresh produce, meats, seafood, and specialty items, as well as a hot bar and bakery. They highlight the clean, well-organized store and the friendly, helpful staff. They also like the convenient Amazon returns and the overall pleasant shopping experience.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d270e-25c4-7568-8340-062a12315aa6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-25c4-7568-8340-062a12315aa6",
        "storage_key": "property/6767906449167046/019d270e-25c4-7568-8340-062a12315aa6.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/jkn?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=13173301360047794626&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "32.354786",
      "poi_longitude": "-90.1495362",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 601-608-0405",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d270e-514b-71ab-9551-36075f99e199.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-514b-71ab-9551-36075f99e199",
        "storage_key": "property/6767906449167046/019d270e-514b-71ab-9551-36075f99e199.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJh8w7oKoyKIYRwqnRtMr30LY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_551538a7-0dc5-476e-9fdf-b53d5128f474",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "custom",
      "poi_name": "Kroger",
      "poi_type": "Shopping & Retail",
      "poi_address": "4910 I-55, Jackson, MS 39211, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_long_description": "People say this grocery store offers fresh produce and unique brands. They also highlight the helpful staff and the meat market with a butcher on hand.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d270e-253a-75d3-99d4-48316760b3d0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-253a-75d3-99d4-48316760b3d0",
        "storage_key": "property/6767906449167046/019d270e-253a-75d3-99d4-48316760b3d0.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.kroger.com/stores/grocery/ms/jackson/jacksonian-plaza/025/00345?cid=loc_02500345_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=12562485936542992699&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kroger",
      "poi_latitude": "32.3637911",
      "poi_longitude": "-90.1479131",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 601-366-1141",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d270e-514b-71ab-9551-36075f99e199.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-514b-71ab-9551-36075f99e199",
        "storage_key": "property/6767906449167046/019d270e-514b-71ab-9551-36075f99e199.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJp_-AxKsyKIYRO0l8f2bqVq4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_c68e3653-adc3-4b5f-9b43-eb6e7b13e2ac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "custom",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "120 Ridge Way, Flowood, MS 39232, USA",
      "poi_short_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_long_description": "People say this home improvement store offers a wide variety of products. They also highlight the helpful staff and the well-stocked shelves.\n\nOther reviews mention delivery can be unreliable.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d270e-2836-7000-bcba-81acec8740ff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-2836-7000-bcba-81acec8740ff",
        "storage_key": "property/6767906449167046/019d270e-2836-7000-bcba-81acec8740ff.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/MS-Flowood/2553?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-2553-_-na-_-0-_-0&y_source=1_MTE4MzYzNi03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=9943658338956026944&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lowes-home-improvement",
      "poi_latitude": "32.343568",
      "poi_longitude": "-90.05779",
      "poi_miles_from_property": "9.1",
      "poi_walking_minutes": "3 hours 20 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 601-992-8475",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d270e-5157-77f3-962a-e6d251d35bfa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-5157-77f3-962a-e6d251d35bfa",
        "storage_key": "property/6767906449167046/019d270e-5157-77f3-962a-e6d251d35bfa.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJAeOQyEcrKIYRQCRTVZP4_ok",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_db8ac57e-4526-4386-b094-a5ea4d6ec0c4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "custom",
      "poi_name": "Renaissance at Colony Park",
      "poi_type": "Shopping & Retail",
      "poi_address": "1000 Highland Colony Pkwy, Ridgeland, MS 39157, USA",
      "poi_short_description": "Brand-name & upmarket boutiques in an elegant outdoor shopping plaza with cafes & play areas.",
      "poi_long_description": "People say this shopping center offers a wide variety of stores and shops, and features a beautiful fountain and outdoor green area. They highlight the European-style architecture, clean and well-maintained environment, and fun shopping experience. They also like the nice vibes and the water show near the theater.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d270e-2978-73eb-abe8-7cc49b571ec3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-2978-73eb-abe8-7cc49b571ec3",
        "storage_key": "property/6767906449167046/019d270e-2978-73eb-abe8-7cc49b571ec3.webp",
        "width": 701,
        "height": 396
      },
      "poi_business_url": "https://renaissanceatcolonypark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1390767190390103411&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "renaissance-at-colony-park",
      "poi_latitude": "32.4356677",
      "poi_longitude": "-90.1465128",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 601-519-0900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d270e-5157-77f3-962a-e6d251d35bfa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-5157-77f3-962a-e6d251d35bfa",
        "storage_key": "property/6767906449167046/019d270e-5157-77f3-962a-e6d251d35bfa.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJr8vq_wjSKYYRc114HGT_TBM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_a39ce637-5f1c-41df-9ac8-f9cc259af12e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "custom",
      "poi_name": "Holmes Community College",
      "poi_type": "Education",
      "poi_address": "412 W Ridgeland Ave, Ridgeland, MS 39157, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d270e-29b7-778a-8dd6-4c75e69f5f07.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-29b7-778a-8dd6-4c75e69f5f07",
        "storage_key": "property/6767906449167046/019d270e-29b7-778a-8dd6-4c75e69f5f07.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://holmescc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6907095702532732739&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "holmes-community-college",
      "poi_latitude": "32.4371517",
      "poi_longitude": "-90.1391745",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 601-605-3300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d270e-512a-738c-b9d1-9ab442c2c43c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-512a-738c-b9d1-9ab442c2c43c",
        "storage_key": "property/6767906449167046/019d270e-512a-738c-b9d1-9ab442c2c43c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ5RKR5BrSKYYRQzcXM_Lu2l8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_ec180e31-4734-482b-9de1-6cc2df44c129",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "custom",
      "poi_name": "Tougaloo College",
      "poi_type": "Education",
      "poi_address": "500 W County Line Rd, Tougaloo, MS 39174, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d270e-2b51-72ea-8877-011c28572be1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-2b51-72ea-8877-011c28572be1",
        "storage_key": "property/6767906449167046/019d270e-2b51-72ea-8877-011c28572be1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.tougaloo.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11573720754771851030&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tougaloo-college",
      "poi_latitude": "32.4048193",
      "poi_longitude": "-90.160845",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 601-977-7700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d270e-512a-738c-b9d1-9ab442c2c43c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-512a-738c-b9d1-9ab442c2c43c",
        "storage_key": "property/6767906449167046/019d270e-512a-738c-b9d1-9ab442c2c43c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJewwN-pzNKYYRFve9zbQdnqA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_db99b936-8b7d-4db8-9a6d-89cbf4c850cf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "custom",
      "poi_name": "Urban Air Trampoline and Adventure Park",
      "poi_type": "Entertainment",
      "poi_address": "6370 Ridgewood Ct Dr, Jackson, MS 39211, USA",
      "poi_short_description": "Trampoline park featuring multiple jumping areas, plus go-karts, arcade games and a zip line.",
      "poi_long_description": "People say this amusement park offers a wide variety of fun activities, including trampolines, zip lines, obstacle courses, and arcade games. They highlight the great value, family-friendly atmosphere, and clean facility. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d270e-2d6f-720c-9e24-a94def0df7cb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-2d6f-720c-9e24-a94def0df7cb",
        "storage_key": "property/6767906449167046/019d270e-2d6f-720c-9e24-a94def0df7cb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.urbanair.com/mississippi-jackson/?utm_source=gmb&utm_medium=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=3514114226054270296&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "urban-air-trampoline-and-adventure-park",
      "poi_latitude": "32.3958583",
      "poi_longitude": "-90.1364822",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 601-566-1631",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d270e-552a-778a-b5a0-36149cbc14ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-552a-778a-b5a0-36149cbc14ad",
        "storage_key": "property/6767906449167046/019d270e-552a-778a-b5a0-36149cbc14ad.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-9gZoZjTKYYRWI0cIEWkxDA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_57464717-ae89-411a-89eb-7c29064b2949",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "custom",
      "poi_name": "Sky Zone Trampoline Park",
      "poi_type": "Entertainment",
      "poi_address": "2000 E County Line Rd Suite B, Ridgeland, MS 39157, USA",
      "poi_short_description": "Chain of indoor trampoline parks featuring freestyle bouncing, dodgeball, fitness programs & more.",
      "poi_long_description": "People say this amusement park is a fun place for kids and adults to have birthday parties. They also highlight the professional and attentive staff, and the good management.\n\nOther reviews mention the offerings can be limited.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d270e-2f58-74fd-a2e9-df9d65abec67.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-2f58-74fd-a2e9-df9d65abec67",
        "storage_key": "property/6767906449167046/019d270e-2f58-74fd-a2e9-df9d65abec67.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.skyzone.com/ridgeland/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15573673565696973962&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sky-zone-trampoline-park",
      "poi_latitude": "32.400928",
      "poi_longitude": "-90.109942",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 601-899-0015",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d270e-552a-778a-b5a0-36149cbc14ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-552a-778a-b5a0-36149cbc14ad",
        "storage_key": "property/6767906449167046/019d270e-552a-778a-b5a0-36149cbc14ad.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJz8_ZewDTKYYRilxCW5jNINg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_1e728ae8-beee-4d8f-bcbc-2f2d7e4f3c1b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "custom",
      "poi_name": "DEFY Jackson",
      "poi_type": "Entertainment",
      "poi_address": "2280 Lakeland Dr, Jackson, MS 39232, USA",
      "poi_short_description": "Kid-friendly bounce center with a ninja-style obstacle course, dodgeball and foam pits.",
      "poi_long_description": "People say this amusement park offers fun activities for kids, including jumping. They also highlight the organized party booking process and helpful staff.\n\nOther reviews mention the membership can be confusing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d270e-2ed8-70ca-8d94-5b0cd4b964a9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-2ed8-70ca-8d94-5b0cd4b964a9",
        "storage_key": "property/6767906449167046/019d270e-2ed8-70ca-8d94-5b0cd4b964a9.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "https://defy.com/defy-jackson/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10670914183626614326&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "defy-jackson",
      "poi_latitude": "32.3315296",
      "poi_longitude": "-90.12563",
      "poi_miles_from_property": "8.8",
      "poi_walking_minutes": "3 hours 14 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 769-208-3008",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d270e-552a-778a-b5a0-36149cbc14ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-552a-778a-b5a0-36149cbc14ad",
        "storage_key": "property/6767906449167046/019d270e-552a-778a-b5a0-36149cbc14ad.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQRfI-xUtKIYRNua9v-mzFpQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_9c8a4ac0-b79d-4042-8160-a92be88c1761",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "custom",
      "poi_name": "St Andrew's Episcopal School Stadium",
      "poi_type": "Entertainment",
      "poi_address": "370 Old Agency Rd, Ridgeland, MS 39157, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3509063169329439257&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "st-andrews-episcopal-school-stadium",
      "poi_latitude": "32.4334556",
      "poi_longitude": "-90.1558001",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 601-853-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d270e-54f0-7654-a79a-b2975d2a4799.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-54f0-7654-a79a-b2975d2a4799",
        "storage_key": "property/6767906449167046/019d270e-54f0-7654-a79a-b2975d2a4799.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJoVkfYCTNKYYRGaJJVlyysjA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_ac35b369-b727-48a3-80ce-6890e868164a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "custom",
      "poi_name": "Choctaw Agency",
      "poi_type": "Entertainment",
      "poi_address": "Ridgeland, MS 39157, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d270e-3048-74aa-8b7a-67dbf81ddd61.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-3048-74aa-8b7a-67dbf81ddd61",
        "storage_key": "property/6767906449167046/019d270e-3048-74aa-8b7a-67dbf81ddd61.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9313327489984509089&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "choctaw-agency",
      "poi_latitude": "32.4307116",
      "poi_longitude": "-90.1530401",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d270e-552a-778a-b5a0-36149cbc14ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-552a-778a-b5a0-36149cbc14ad",
        "storage_key": "property/6767906449167046/019d270e-552a-778a-b5a0-36149cbc14ad.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJny1iVdfNKYYRoTRoDQKWP4E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "custom_afde51d6-c10d-4565-9bfd-8041e50b8722",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "772 Lake Harbour Dr Ste 1, Ridgeland, MS 39157, USA",
      "poi_short_description": "Clean gym chain featuring a cardio area, weight machines and a 24-hour schedule.",
      "poi_long_description": "People say this gym has a wide variety of well-maintained equipment, including treadmills, ellipticals, bikes, rowing machines, and weight machines, and they appreciate the spacious layout. They also highlight the friendly and helpful staff, and the clean and well-lit facility.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d270e-3409-7256-87c2-a7260f7a2781.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-3409-7256-87c2-a7260f7a2781",
        "storage_key": "property/6767906449167046/019d270e-3409-7256-87c2-a7260f7a2781.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/ridgeland-ms?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=17295786995903098070&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "32.41556",
      "poi_longitude": "-90.11079",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 601-427-5901",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d270e-552a-778a-b5a0-36149cbc14ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-552a-778a-b5a0-36149cbc14ad",
        "storage_key": "property/6767906449167046/019d270e-552a-778a-b5a0-36149cbc14ad.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJiSGVmpnTKYYR1uyfwaL6BvA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_8a664b10-a302-426e-b989-b7cf7ac9848e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "custom",
      "poi_name": "CLUB4 Fitness Lake Harbour",
      "poi_type": "Health and Wellness",
      "poi_address": "511 Lake Harbour Dr, Ridgeland, MS 39157, USA",
      "poi_short_description": "Membership-only gym offering equipment, classes, child care, a pool, and a rock climbing wall.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, classes, and training options, and has a comfortable atmosphere. They also highlight the friendly staff, clean facility, and reasonable membership prices.\n\nSome reviews mention the equipment can be poorly maintained.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d270e-336b-7339-97ab-d77d6f8b2cc9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-336b-7339-97ab-d77d6f8b2cc9",
        "storage_key": "property/6767906449167046/019d270e-336b-7339-97ab-d77d6f8b2cc9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.club4fitness.com/location/lake-harbour/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6318120847339163222&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "club4-fitness-lake-harbour",
      "poi_latitude": "32.4133465",
      "poi_longitude": "-90.1175495",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 601-605-9886",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d270e-552a-778a-b5a0-36149cbc14ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-552a-778a-b5a0-36149cbc14ad",
        "storage_key": "property/6767906449167046/019d270e-552a-778a-b5a0-36149cbc14ad.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSTFhXUPSKYYRVg6kkW95rlc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_fdb5934b-026d-4946-ad0c-18a42c35bd00",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "custom",
      "poi_name": "Ancee Nail Lounge",
      "poi_type": "Health and Wellness",
      "poi_address": "1855 Lakeland Dr # E10, Jackson, MS 39216, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d270e-3429-7524-869b-670a87f7bf3e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-3429-7524-869b-670a87f7bf3e",
        "storage_key": "property/6767906449167046/019d270e-3429-7524-869b-670a87f7bf3e.webp",
        "width": 1280,
        "height": 1202
      },
      "poi_business_url": "https://anceenaillounge.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11516596813459570638&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ancee-nail-lounge",
      "poi_latitude": "32.3331343",
      "poi_longitude": "-90.1396647",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 54 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 601-368-6868",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d270e-552a-778a-b5a0-36149cbc14ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-552a-778a-b5a0-36149cbc14ad",
        "storage_key": "property/6767906449167046/019d270e-552a-778a-b5a0-36149cbc14ad.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJR1nZRQwtKIYRzj-nx8gr058",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_81259e39-ac9a-4d81-bc6c-22986b6167e0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "custom",
      "poi_name": "Crunch Fitness - Ridgeland",
      "poi_type": "Health and Wellness",
      "poi_address": "2000 E County Line Rd, Ridgeland, MS 39157, USA",
      "poi_short_description": "Fitness center featuring various classes (including spinning), treadmills, weights and friendly staff.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d270e-356c-75e9-bacc-e884e3f24b30.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-356c-75e9-bacc-e884e3f24b30",
        "storage_key": "property/6767906449167046/019d270e-356c-75e9-bacc-e884e3f24b30.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.crunch.com/locations/ridgeland",
      "poi_directions_map_url": "https://maps.google.com/?cid=16000032341730509397&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---ridgeland",
      "poi_latitude": "32.4010391",
      "poi_longitude": "-90.1096038",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 601-360-8080",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d270e-552a-778a-b5a0-36149cbc14ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-552a-778a-b5a0-36149cbc14ad",
        "storage_key": "property/6767906449167046/019d270e-552a-778a-b5a0-36149cbc14ad.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNfpJ8fjSKYYRVcKbm6SIC94",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_d92c4de1-5473-47ef-b948-1c79690ca26b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "custom",
      "poi_name": "Sport Clips Haircuts of Flowood - Lakeland Drive",
      "poi_type": "Health and Wellness",
      "poi_address": "163 Ridge Way E, Flowood, MS 39232, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d270e-381e-722d-9984-7e7b859ad0a9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-381e-722d-9984-7e7b859ad0a9",
        "storage_key": "property/6767906449167046/019d270e-381e-722d-9984-7e7b859ad0a9.webp",
        "width": 1279,
        "height": 720
      },
      "poi_business_url": "https://sportclips.com/us-ms-flowood-ms101?utm_source=google&utm_medium=link&utm_campaign=gbp&utm_content=soci",
      "poi_directions_map_url": "https://maps.google.com/?cid=9886910044159362539&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sport-clips-haircuts-of-flowood---lakeland-drive",
      "poi_latitude": "32.3395694",
      "poi_longitude": "-90.0703666",
      "poi_miles_from_property": "9.9",
      "poi_walking_minutes": "3 hours 39 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 601-992-2733",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d270e-552a-778a-b5a0-36149cbc14ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-552a-778a-b5a0-36149cbc14ad",
        "storage_key": "property/6767906449167046/019d270e-552a-778a-b5a0-36149cbc14ad.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHfbKwFsrKIYR60VcVE1cNYk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_88ee3b56-bea8-4222-acba-3d362cfe14af",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "custom",
      "poi_name": "Madison Healthplex Performance Training Center",
      "poi_type": "Health and Wellness",
      "poi_address": "501 Baptist Dr, Madison, MS 39110, USA",
      "poi_short_description": "Large gym with a pool, hot tub, and cold plunge, plus a variety of group classes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d270e-38db-7712-91d6-fa293d65aa42.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-38db-7712-91d6-fa293d65aa42",
        "storage_key": "property/6767906449167046/019d270e-38db-7712-91d6-fa293d65aa42.webp",
        "width": 981,
        "height": 768
      },
      "poi_business_url": "http://www.healthplexperformance.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10695343614279382681&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "madison-healthplex-performance-training-center",
      "poi_latitude": "32.470621",
      "poi_longitude": "-90.1372865",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 601-856-7757",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d270e-552a-778a-b5a0-36149cbc14ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-552a-778a-b5a0-36149cbc14ad",
        "storage_key": "property/6767906449167046/019d270e-552a-778a-b5a0-36149cbc14ad.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJV0v5kMLRKYYRmXbdz1l-bZQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_87388a10-5939-429e-beca-4ae3af77a19d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "custom",
      "poi_name": "Courthouse Gymnastics Cou",
      "poi_type": "Health and Wellness",
      "poi_address": "698 Liberty Rd, Flowood, MS 39232, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d270e-38ad-726a-8ffa-fa11b78c953a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-38ad-726a-8ffa-fa11b78c953a",
        "storage_key": "property/6767906449167046/019d270e-38ad-726a-8ffa-fa11b78c953a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.courthousegymnastics.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10353510153888683355&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "courthouse-gymnastics-cou",
      "poi_latitude": "32.3435763",
      "poi_longitude": "-90.0878897",
      "poi_miles_from_property": "11.1",
      "poi_walking_minutes": "4 hours 2 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 601-932-6680",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d270e-512a-738c-b9d1-9ab442c2c43c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-512a-738c-b9d1-9ab442c2c43c",
        "storage_key": "property/6767906449167046/019d270e-512a-738c-b9d1-9ab442c2c43c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJhS3gP_osKIYRW1XvNKEOr48",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_8b5e0420-7c26-4c11-a75b-d668d14cdb00",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "custom",
      "poi_name": "The Club at The Township",
      "poi_type": "Health and Wellness",
      "poi_address": "340 Township Ave, Ridgeland, MS 39157, USA",
      "poi_short_description": "Gym featuring a sauna, Olympic-size and resort-style pools, plus tennis courts and a swim program.",
      "poi_long_description": "People say this gym offers a wide variety of clean, modern equipment for strength training, cardio, and functional fitness, as well as a spacious pool, tennis courts, and a sauna. They highlight the excellent amenities, including spotless locker rooms, showers, and massage chairs, and the welcoming, supportive, and motivating atmosphere. They also like the friendly, knowledgeable, and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d270e-3c5a-7778-bfe8-539463154c4d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-3c5a-7778-bfe8-539463154c4d",
        "storage_key": "property/6767906449167046/019d270e-3c5a-7778-bfe8-539463154c4d.webp",
        "width": 1280,
        "height": 799
      },
      "poi_business_url": "http://www.theclubms.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10155285273860788701&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-club-at-the-township",
      "poi_latitude": "32.4428266",
      "poi_longitude": "-90.1535217",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 601-856-0668",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d270e-552a-778a-b5a0-36149cbc14ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-552a-778a-b5a0-36149cbc14ad",
        "storage_key": "property/6767906449167046/019d270e-552a-778a-b5a0-36149cbc14ad.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJnSvJx_bSKYYR3VE6zSbS7ow",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_ea76a429-8b91-4726-a9d2-21b0b983fd3d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "custom",
      "poi_name": "CLUB4 Fitness Flowood",
      "poi_type": "Health and Wellness",
      "poi_address": "5352 Lakeland Dr, Flowood, MS 39232, USA",
      "poi_short_description": "Workout venue offering weights, cardio equipment, shower and tanning beds, plus helpful staff.",
      "poi_long_description": "People say this gym offers a wide variety of equipment and is a great place to work out. They also highlight the friendly and helpful staff, and the clean and comfortable atmosphere.\n\nSome reviews mention equipment parts can be missing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d270e-3c8e-7418-b53a-4101a9cff432.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-3c8e-7418-b53a-4101a9cff432",
        "storage_key": "property/6767906449167046/019d270e-3c8e-7418-b53a-4101a9cff432.webp",
        "width": 1280,
        "height": 817
      },
      "poi_business_url": "https://www.club4fitness.com/location/flowood/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16024035587796611071&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "club4-fitness-flowood",
      "poi_latitude": "32.3519327",
      "poi_longitude": "-90.03326260000001",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 43 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 601-658-9559",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d270e-552a-778a-b5a0-36149cbc14ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-552a-778a-b5a0-36149cbc14ad",
        "storage_key": "property/6767906449167046/019d270e-552a-778a-b5a0-36149cbc14ad.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIzrXEtQqKIYR_6_V1nfPYN4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_a6bbd71d-781c-4b71-9dd0-722414f8721c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "custom",
      "poi_name": "Merit Health Woman's Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "1026 N Flowood Dr, Flowood, MS 39232, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d270e-3d0f-767f-a5f9-14549895f59b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-3d0f-767f-a5f9-14549895f59b",
        "storage_key": "property/6767906449167046/019d270e-3d0f-767f-a5f9-14549895f59b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.merithealthwomanshospital.com/?utm_source=gmb&utm_medium=homepage&utm_campaign=biz-listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=1362643556699573440&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "merit-health-womans-hospital",
      "poi_latitude": "32.329577",
      "poi_longitude": "-90.1014761",
      "poi_miles_from_property": "10.3",
      "poi_walking_minutes": "3 hours 47 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 601-932-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d270e-5504-760c-afa6-26cc0f6aa727.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-5504-760c-afa6-26cc0f6aa727",
        "storage_key": "property/6767906449167046/019d270e-5504-760c-afa6-26cc0f6aa727.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJF7Cn7ugsKIYRwIyNYBgV6RI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_30651cf8-ca70-4b32-8658-7ac829f0b297",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "custom",
      "poi_name": "Select Specialty Hospital - Jackson",
      "poi_type": "Health and Wellness",
      "poi_address": "5903 Ridgewood Rd, Jackson, MS 39211, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d270e-3de7-7222-ba18-352810b7dbdf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-3de7-7222-ba18-352810b7dbdf",
        "storage_key": "property/6767906449167046/019d270e-3de7-7222-ba18-352810b7dbdf.webp",
        "width": 1062,
        "height": 602
      },
      "poi_business_url": "https://www.selectspecialtyhospitals.com/locations-and-tours/MS/Jackson/Jackson?ty=xt",
      "poi_directions_map_url": "https://maps.google.com/?cid=7423628704691124967&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "select-specialty-hospital---jackson",
      "poi_latitude": "32.389692",
      "poi_longitude": "-90.1437543",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 601-899-3800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d270e-5504-760c-afa6-26cc0f6aa727.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-5504-760c-afa6-26cc0f6aa727",
        "storage_key": "property/6767906449167046/019d270e-5504-760c-afa6-26cc0f6aa727.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ_rtNJvSKYYR5_qBj_kGBmc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_d325d2e1-6b87-4a02-9b1a-690d693db485",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "custom",
      "poi_name": "Freedom Ridge",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "253 W School St, Ridgeland, MS 39157, USA",
      "poi_short_description": "Baseball, softball & soccer fields plus 2 playgrounds, 1 for children with varying abilities.",
      "poi_long_description": "People say this park is very big and fun for kids, and also great for soccer games. They highlight the clean and friendly environment, and the easy access between fields. They also like that it's safe. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d270e-4170-703b-99b7-4c83f0de9821.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-4170-703b-99b7-4c83f0de9821",
        "storage_key": "property/6767906449167046/019d270e-4170-703b-99b7-4c83f0de9821.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.ridgelandms.org/city-departments/recreation-and-parks/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15546985984956168474&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "freedom-ridge",
      "poi_latitude": "32.4197477",
      "poi_longitude": "-90.1413081",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 601-853-2011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d270e-553b-756b-85d4-58554b38f69f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-553b-756b-85d4-58554b38f69f",
        "storage_key": "property/6767906449167046/019d270e-553b-756b-85d4-58554b38f69f.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJwSKa83HSKYYRGvlJwWH9wdc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_c81f4c74-fa40-4ad9-95cc-edcb8933883d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "custom",
      "poi_name": "Winners Circle Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "100 Winners Cir, Flowood, MS 39232, USA",
      "poi_short_description": "Landscaped park with an amphitheater, open air pavilions, a playground & lit tennis courts.",
      "poi_long_description": "Visitors say this park has well-maintained playgrounds and tennis courts, and they appreciate the beautiful nature. They also highlight that the playground is suitable for all ages, making it a great spot for families with young children.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d270e-41c1-70ab-b0ce-678812592121.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-41c1-70ab-b0ce-678812592121",
        "storage_key": "property/6767906449167046/019d270e-41c1-70ab-b0ce-678812592121.webp",
        "width": 1000,
        "height": 750
      },
      "poi_business_url": "https://www.cityofflowood.com/winner%E2%80%99s-circle-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=4454325228718501489&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "winners-circle-park",
      "poi_latitude": "32.3470087",
      "poi_longitude": "-90.0625008",
      "poi_miles_from_property": "9.5",
      "poi_walking_minutes": "3 hours 26 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 601-992-4440",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d270e-553b-756b-85d4-58554b38f69f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-553b-756b-85d4-58554b38f69f",
        "storage_key": "property/6767906449167046/019d270e-553b-756b-85d4-58554b38f69f.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJt9jH-04rKIYRca7TCzLx0D0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_3e1456c1-4cf0-456d-bab9-f86a71277901",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "custom",
      "poi_name": "Old Trace Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "422 Post Rd, Ridgeland, MS 39157, USA",
      "poi_short_description": "Recreation area with picnic tables & reservoir views, plus an annual show by the local symphony.",
      "poi_long_description": "People say this park offers a dog park, recreation center, playground, and accessible swimming, as well as a disc golf course and lakeside trail. They highlight the spaciousness, beautiful views of the reservoir, and peaceful atmosphere, especially at sunset. They also like the convenient parking and gazebos for picnics and relaxation.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d270e-422b-723a-817d-e3860ad120d9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-422b-723a-817d-e3860ad120d9",
        "storage_key": "property/6767906449167046/019d270e-422b-723a-817d-e3860ad120d9.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.therez.ms.gov/parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=2671602723425758356&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "old-trace-park",
      "poi_latitude": "32.4274039",
      "poi_longitude": "-90.0823689",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 601-856-6574",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d270e-553b-756b-85d4-58554b38f69f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-553b-756b-85d4-58554b38f69f",
        "storage_key": "property/6767906449167046/019d270e-553b-756b-85d4-58554b38f69f.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJCfITFPPTKYYRlCzCroVwEyU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_d1dc2ea1-a4e8-4812-8ddd-b6595f8bffce",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "custom",
      "poi_name": "Flowood Liberty Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Unnamed Road, Flowood, MS 39232, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d270e-42e7-7358-839a-0492df938276.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-42e7-7358-839a-0492df938276",
        "storage_key": "property/6767906449167046/019d270e-42e7-7358-839a-0492df938276.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8220269399056143777&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "flowood-liberty-park",
      "poi_latitude": "32.3464135",
      "poi_longitude": "-90.0864976",
      "poi_miles_from_property": "11.3",
      "poi_walking_minutes": "4 hours 6 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d270e-553b-756b-85d4-58554b38f69f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-553b-756b-85d4-58554b38f69f",
        "storage_key": "property/6767906449167046/019d270e-553b-756b-85d4-58554b38f69f.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJw0z5Z5wtKIYRoVXBMHdDFHI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_5e7826af-b1e0-4de5-8b27-170b746f09ce",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "custom",
      "poi_name": "Flowood Nature Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4077 Flowood Dr, Flowood, MS 39232, USA",
      "poi_short_description": "Paved & marked trails through dense woods are among the highlights at this 40-acre park & lake site.",
      "poi_long_description": "People say this park offers a well-maintained walking trail, a pond with wildlife, and picnic pavilions with BBQ pits. They highlight the peaceful and relaxing atmosphere, and the clean and safe environment. They also like the informative signage along the trails and the availability of restrooms and water fountains for adults, children, and pets.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d270e-463e-72d9-b7cb-a4d16f637995.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-463e-72d9-b7cb-a4d16f637995",
        "storage_key": "property/6767906449167046/019d270e-463e-72d9-b7cb-a4d16f637995.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.cityofflowood.com/flowood-nature-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=6452044323503789375&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "flowood-nature-park",
      "poi_latitude": "32.348192",
      "poi_longitude": "-90.0582452",
      "poi_miles_from_property": "9.2",
      "poi_walking_minutes": "3 hours 21 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 601-992-4440",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d270e-553b-756b-85d4-58554b38f69f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-553b-756b-85d4-58554b38f69f",
        "storage_key": "property/6767906449167046/019d270e-553b-756b-85d4-58554b38f69f.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJnaXwdEkrKIYRP9WEuSBEilk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_58ddf2bb-e46d-4ff8-969d-57893e874426",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "custom",
      "poi_name": "Bruce Campbell Field",
      "poi_type": "Transportation & Transit",
      "poi_address": "7450 Old Canton Rd, Madison, MS 39110, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d270e-4758-747c-80e8-4040ddfeffff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-4758-747c-80e8-4040ddfeffff",
        "storage_key": "property/6767906449167046/019d270e-4758-747c-80e8-4040ddfeffff.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.madisonthecity.com/government/airport/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9202379395653693271&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bruce-campbell-field",
      "poi_latitude": "32.4400825",
      "poi_longitude": "-90.1052932",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 601-853-1960",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d270e-58ab-74fc-bddd-054d4d6894b9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-58ab-74fc-bddd-054d4d6894b9",
        "storage_key": "property/6767906449167046/019d270e-58ab-74fc-bddd-054d4d6894b9.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJfRqzhNDTKYYRV-9P1k1rtX8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_bafe674b-ce19-4b8c-9601-e6e73ba07026",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "custom",
      "poi_name": "Madison Air LLC.",
      "poi_type": "Transportation & Transit",
      "poi_address": "7450 Old Canton Rd, Madison, MS 39110, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d270e-4749-7206-af4b-6718348d7bb6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-4749-7206-af4b-6718348d7bb6",
        "storage_key": "property/6767906449167046/019d270e-4749-7206-af4b-6718348d7bb6.webp",
        "width": 1280,
        "height": 761
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11203969235679198100&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "madison-air-llc",
      "poi_latitude": "32.4401776",
      "poi_longitude": "-90.1051652",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 601-853-1960",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d270e-58ab-74fc-bddd-054d4d6894b9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-58ab-74fc-bddd-054d4d6894b9",
        "storage_key": "property/6767906449167046/019d270e-58ab-74fc-bddd-054d4d6894b9.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJKYe6J9HTKYYRlDsQn6h-fJs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_928d364d-a362-4b3c-899a-ab0b26fe03df",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "custom",
      "poi_name": "The Powerhouse, Entergy",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1350 Echelon Pkwy, Jackson, MS 39213, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d270e-4806-711e-a379-268007ae1858.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-4806-711e-a379-268007ae1858",
        "storage_key": "property/6767906449167046/019d270e-4806-711e-a379-268007ae1858.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8770278893550025776&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-powerhouse-entergy",
      "poi_latitude": "32.396321",
      "poi_longitude": "-90.191046",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 40 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 601-952-2200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d270e-552a-778a-b5a0-36149cbc14ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-552a-778a-b5a0-36149cbc14ad",
        "storage_key": "property/6767906449167046/019d270e-552a-778a-b5a0-36149cbc14ad.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKaisuv7MKYYRMLwnzy9Ktnk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_121f0164-3710-4576-821e-2923d94123dd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "custom",
      "poi_name": "Entergy Transmission HQ",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6540 Watkins Dr, Jackson, MS 39213, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d270e-4d0d-7699-966f-dbd429042926.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-4d0d-7699-966f-dbd429042926",
        "storage_key": "property/6767906449167046/019d270e-4d0d-7699-966f-dbd429042926.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://entergy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1578563261303676078&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "entergy-transmission-hq",
      "poi_latitude": "32.3975051",
      "poi_longitude": "-90.1912372",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d270e-552a-778a-b5a0-36149cbc14ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-552a-778a-b5a0-36149cbc14ad",
        "storage_key": "property/6767906449167046/019d270e-552a-778a-b5a0-36149cbc14ad.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJw2H9zv7MKYYRrtx8Lewu6BU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_644b1585-16e2-433f-bc23-fbe19c32194a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "custom",
      "poi_name": "C Spire Corporate Headquarters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1018 Highland Colony Pkwy, Ridgeland, MS 39157, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d270e-4bde-7317-84dc-a3e553ca2104.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270e-4bde-7317-84dc-a3e553ca2104",
        "storage_key": "property/6767906449167046/019d270e-4bde-7317-84dc-a3e553ca2104.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://www.cspire.com/business",
      "poi_directions_map_url": "https://maps.google.com/?cid=8383002471184058399&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "c-spire-corporate-headquarters",
      "poi_latitude": "32.437348",
      "poi_longitude": "-90.147231",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 866-455-9628",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d270e-552a-778a-b5a0-36149cbc14ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-552a-778a-b5a0-36149cbc14ad",
        "storage_key": "property/6767906449167046/019d270e-552a-778a-b5a0-36149cbc14ad.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJv0s2rPXTKYYRH8glHlVoVnQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_c828d8aa-f627-49f4-a189-5941c7dc2965",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "custom",
      "poi_name": "MDHS- Child Support Services",
      "poi_type": "Major Employers & Offices",
      "poi_address": "950 E County Line Rd, Ridgeland, MS 39157, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.mdhs.ms.gov/child-support/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1738695405663311359&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mdhs--child-support-services",
      "poi_latitude": "32.4004974",
      "poi_longitude": "-90.1374969",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 601-359-4500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d270e-552a-778a-b5a0-36149cbc14ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-552a-778a-b5a0-36149cbc14ad",
        "storage_key": "property/6767906449167046/019d270e-552a-778a-b5a0-36149cbc14ad.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJu1njEqnTKYYR_1Uqa0IWIRg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_c13786c9-c4a7-417f-820f-ea0b6267b9a1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "custom",
      "poi_name": "Cal-Maine Foods, Inc.",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1052 Highland Colony Pkwy, Ridgeland, MS 39157, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://calmainefoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17133107250284266322&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cal-maine-foods-inc",
      "poi_latitude": "32.4102297",
      "poi_longitude": "-90.1139188",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 601-948-6813",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d270e-552a-778a-b5a0-36149cbc14ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270e-552a-778a-b5a0-36149cbc14ad",
        "storage_key": "property/6767906449167046/019d270e-552a-778a-b5a0-36149cbc14ad.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHZm8XmIzKIYRUgPd30QGxe0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_74f5588a-e2b6-4d28-8a54-a4fc2042f3b7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "custom",
      "poi_name": "Ann Smith Elementary School",
      "poi_type": "Education",
      "poi_address": "306 S Pear Orchard Rd, Ridgeland, MS 39157, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019cfb54-0bd4-7418-8056-a07ccca0f374.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb54-0bd4-7418-8056-a07ccca0f374",
        "storage_key": "property/6767906449167046/019cfb54-0bd4-7418-8056-a07ccca0f374.webp",
        "width": 533,
        "height": 400
      },
      "poi_business_url": "http://www.madison-schools.com/ase",
      "poi_directions_map_url": "https://maps.google.com/?cid=2820663062739685371&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "ann-smith-elementary-school",
      "poi_latitude": "32.420476",
      "poi_longitude": "-90.1220605",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 601-856-6621",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019cfb54-2871-75aa-9d04-253fc87fab99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb54-2871-75aa-9d04-253fc87fab99",
        "storage_key": "property/6767906449167046/019cfb54-2871-75aa-9d04-253fc87fab99.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ6yCSN0bSKYYR-w-qbRwCJSc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_1fbb4b61-08a7-4a18-beeb-61aa2a96b835",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "custom",
      "poi_name": "First Source",
      "poi_type": "Education",
      "poi_address": "109 Pne Knl Dr, Ridgeland, MS 39157, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=10638741567099098369&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "first-source",
      "poi_latitude": "32.4005187",
      "poi_longitude": "-90.1042117",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 601-952-0556",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019cfb54-2871-75aa-9d04-253fc87fab99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb54-2871-75aa-9d04-253fc87fab99",
        "storage_key": "property/6767906449167046/019cfb54-2871-75aa-9d04-253fc87fab99.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ8zBYGarTKYYRAdUfvBZnpJM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "custom_f9b783af-9279-4ae5-b7ea-05603b585760",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "custom",
      "poi_name": "Christ Covenant School",
      "poi_type": "Education",
      "poi_address": "752 S Pear Orchard Rd, Ridgeland, MS 39157, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d7917-2f45-775c-a00a-9238a83a6b94.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-2f45-775c-a00a-9238a83a6b94",
        "storage_key": "property/6767906449167046/019d7917-2f45-775c-a00a-9238a83a6b94.webp",
        "width": 1031,
        "height": 1280
      },
      "poi_business_url": "http://www.christcovenantschool.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13136412597406305528&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "christ-covenant-school",
      "poi_latitude": "32.402614",
      "poi_longitude": "-90.122468",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 601-978-2272",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019cfb54-2871-75aa-9d04-253fc87fab99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb54-2871-75aa-9d04-253fc87fab99",
        "storage_key": "property/6767906449167046/019cfb54-2871-75aa-9d04-253fc87fab99.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ9Yb0Y1jSKYYR-IxeW6jpTbY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_2bc99a7f-74e3-468e-9c86-dbc28d0879c0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "custom",
      "poi_name": "Highland Elementary School",
      "poi_type": "Education",
      "poi_address": "330 Brame Rd, Ridgeland, MS 39157, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.madison-schools.com/hes",
      "poi_directions_map_url": "https://maps.google.com/?cid=15494384500546725945&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "highland-elementary-school",
      "poi_latitude": "32.4161238",
      "poi_longitude": "-90.1505377",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 601-853-8103",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019cfb54-2871-75aa-9d04-253fc87fab99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb54-2871-75aa-9d04-253fc87fab99",
        "storage_key": "property/6767906449167046/019cfb54-2871-75aa-9d04-253fc87fab99.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJddIAM4rNKYYROehnSJwcB9c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_3d475f40-1b42-4be2-bca9-9fce18991329",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "custom",
      "poi_name": "Ridgeland High School",
      "poi_type": "Education",
      "poi_address": "586 Sunnybrook Rd, Ridgeland, MS 39157, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019cfb54-0cd8-7760-8733-7dea90a6a89a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb54-0cd8-7760-8733-7dea90a6a89a",
        "storage_key": "property/6767906449167046/019cfb54-0cd8-7760-8733-7dea90a6a89a.webp",
        "width": 440,
        "height": 400
      },
      "poi_business_url": "https://rhs.madison-schools.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3513983871240866136&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "ridgeland-high-school",
      "poi_latitude": "32.4445543",
      "poi_longitude": "-90.1360819",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 601-898-5023",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019cfb54-2871-75aa-9d04-253fc87fab99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb54-2871-75aa-9d04-253fc87fab99",
        "storage_key": "property/6767906449167046/019cfb54-2871-75aa-9d04-253fc87fab99.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJOYANuB3SKYYRWInDh7YtxDA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_f666bfef-936a-46d0-ad78-6ac21aad828d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "custom",
      "poi_name": "Old Town Middle School",
      "poi_type": "Education",
      "poi_address": "210 Sunnybrook Rd, Ridgeland, MS 39157, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.madison-schools.com/otm",
      "poi_directions_map_url": "https://maps.google.com/?cid=4526077922393244761&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "old-town-middle-school",
      "poi_latitude": "32.4317835",
      "poi_longitude": "-90.1395532",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 601-898-8730",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019cfb54-2871-75aa-9d04-253fc87fab99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb54-2871-75aa-9d04-253fc87fab99",
        "storage_key": "property/6767906449167046/019cfb54-2871-75aa-9d04-253fc87fab99.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJyawiLQ7SKYYRWcT85ePbzz4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_dbffb5ce-f948-4c60-924f-186914b2f20f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "custom",
      "poi_name": "Kathryn's Steakhouse and Seafood Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "6800 Old Canton Rd #108, Ridgeland, MS 39157, USA",
      "poi_short_description": "Relaxed bar/eatery since 1991 offering steak & seafood dishes, plus live music & TVs showing sports.",
      "poi_long_description": "People say this steakhouse serves delicious steak, prime rib, and filet, and offers a variety of other dishes like pasta Bolognese and stuffed redfish. They also highlight the great service, comfortable seating, and lively atmosphere with live music in the bar area.\n\nSome reviews mention the food can be overcooked.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019cfb54-028f-77d8-971c-15806d831ea6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb54-028f-77d8-971c-15806d831ea6",
        "storage_key": "property/6767906449167046/019cfb54-028f-77d8-971c-15806d831ea6.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.kathrynssteaks.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13077272740773673135&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "kathryn-s-steakhouse-and-seafood-restaurant",
      "poi_latitude": "32.4100512",
      "poi_longitude": "-90.1057078",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 601-956-2803",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019cfb54-2864-70d3-bb80-d67b69f7c1ab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb54-2864-70d3-bb80-d67b69f7c1ab",
        "storage_key": "property/6767906449167046/019cfb54-2864-70d3-bb80-d67b69f7c1ab.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJPUo8Fa7TKYYRr7i2eEXOe7U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_a828e984-6d22-402d-8df7-34bb4662e85d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "custom",
      "poi_name": "Amerigo Italian Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "6592 Old Canton Rd, Ridgeland, MS 39157, USA",
      "poi_short_description": "Local chain outlet with a full bar & a menu of classic Italian dishes in an easygoing atmosphere.",
      "poi_long_description": "People say this Italian restaurant serves delicious veal saltimbocca, chicken piccata, and redfish. They highlight the reasonable prices and generous portions. They also like the friendly and efficient service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d7917-2f44-703b-bce7-ea0b2908ffd4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-2f44-703b-bce7-ea0b2908ffd4",
        "storage_key": "property/6767906449167046/019d7917-2f44-703b-bce7-ea0b2908ffd4.webp",
        "width": 1280,
        "height": 640
      },
      "poi_business_url": "http://www.amerigo.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3134931430254947506&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "amerigo-italian-restaurant",
      "poi_latitude": "32.402115",
      "poi_longitude": "-90.1075574",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 601-977-0563",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019cfb54-2864-70d3-bb80-d67b69f7c1ab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb54-2864-70d3-bb80-d67b69f7c1ab",
        "storage_key": "property/6767906449167046/019cfb54-2864-70d3-bb80-d67b69f7c1ab.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJP94qGKrTKYYRsqyNt4aDgSs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_d662a8db-922f-4a68-9b40-ff79f35d0cd9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "custom",
      "poi_name": "Anjou Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "361 Township Ave, Ridgeland, MS 39157, USA",
      "poi_short_description": "Refined yet relaxed choice with a warm atmosphere & patio serving French bistro favorites & wine.",
      "poi_long_description": "People say this restaurant serves delicious French and Southern cuisine, including redfish, duck, and shrimp and grits. They also highlight the beautiful and inviting atmosphere, and the attentive service.\n\nOther reviews mention the food can be bland.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d7917-3100-719d-8dbb-2d3733f6aae1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-3100-719d-8dbb-2d3733f6aae1",
        "storage_key": "property/6767906449167046/019d7917-3100-719d-8dbb-2d3733f6aae1.webp",
        "width": 1007,
        "height": 1280
      },
      "poi_business_url": "http://anjourestaurant.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2020582554138643919&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "anjou-restaurant",
      "poi_latitude": "32.4426404",
      "poi_longitude": "-90.1529655",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 601-707-0587",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019cfb54-2864-70d3-bb80-d67b69f7c1ab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb54-2864-70d3-bb80-d67b69f7c1ab",
        "storage_key": "property/6767906449167046/019cfb54-2864-70d3-bb80-d67b69f7c1ab.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJU6hHkf7NKYYRzw3JoiCNChw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "french_restaurant"
    },
    {
      "id": "custom_ae8f61ac-1063-47c5-90db-40bb9d7db69d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "custom",
      "poi_name": "Local 463",
      "poi_type": "Restaurants",
      "poi_address": "1000 Highland Colony Pkwy #5002, Ridgeland, MS 39157, USA",
      "poi_short_description": "Southern fare & seafood served in an upscale-casual, modern restaurant with huge windows & bar area.",
      "poi_long_description": "People say this Southern restaurant serves delicious redfish, burgers, and steaks. They highlight the cozy and stylish atmosphere, and the reasonable prices for the quality of food. They also like the friendly and attentive service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d7917-34c5-76b6-8d34-28c6bbbdff7d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-34c5-76b6-8d34-28c6bbbdff7d",
        "storage_key": "property/6767906449167046/019d7917-34c5-76b6-8d34-28c6bbbdff7d.webp",
        "width": 1230,
        "height": 1280
      },
      "poi_business_url": "http://www.local463.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8049323224371311351&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "local-463",
      "poi_latitude": "32.4352322",
      "poi_longitude": "-90.1483322",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 601-707-7684",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019cfb54-2864-70d3-bb80-d67b69f7c1ab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb54-2864-70d3-bb80-d67b69f7c1ab",
        "storage_key": "property/6767906449167046/019cfb54-2864-70d3-bb80-d67b69f7c1ab.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJERA8vtzRKYYR9zL0TtPwtG8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_55577369-b9a1-479e-9140-a9c664742039",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "custom",
      "poi_name": "Green Ghost Tacos",
      "poi_type": "Restaurants",
      "poi_address": "900 E County Line Rd, Ridgeland, MS 39157, USA",
      "poi_short_description": "Casual spot for familiar Mexican favorites such as enchiladas and tacos, plus beer and cocktails.",
      "poi_long_description": "People say this Mexican restaurant serves great food. They also highlight the good portions and free chips and salsa.\n\nOther reviews mention the food can be dry.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019cfb54-0165-76cb-b065-4c91b943c13b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb54-0165-76cb-b065-4c91b943c13b",
        "storage_key": "property/6767906449167046/019cfb54-0165-76cb-b065-4c91b943c13b.webp",
        "width": 542,
        "height": 323
      },
      "poi_business_url": "https://www.greenghosttaco.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14666817192938051108&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "green-ghost-tacos",
      "poi_latitude": "32.40019729999999",
      "poi_longitude": "-90.1392217",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 601-957-7436",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019cfb54-2864-70d3-bb80-d67b69f7c1ab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb54-2864-70d3-bb80-d67b69f7c1ab",
        "storage_key": "property/6767906449167046/019cfb54-2864-70d3-bb80-d67b69f7c1ab.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJD-f_5_XSKYYRJBaqYocAi8s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_9a44b49a-5e4a-4f93-8e20-5ad7faceef59",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "custom",
      "poi_name": "The Trace Grill",
      "poi_type": "Restaurants",
      "poi_address": "574 US-51 suite f, Ridgeland, MS 39157, USA",
      "poi_short_description": "American fare from burgers to Southern favorites in a low-key space adorned with deer trophies.",
      "poi_long_description": "People say this family restaurant serves delicious barbecue, blue plates, burgers, and country fried steak. They highlight the generous portions, reasonable prices, and home cooking vibe. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d7917-415b-76f8-bea5-b166eaa41d8b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-415b-76f8-bea5-b166eaa41d8b",
        "storage_key": "property/6767906449167046/019d7917-415b-76f8-bea5-b166eaa41d8b.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.thetracegrill.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8698330316755939663&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-trace-grill",
      "poi_latitude": "32.4317129",
      "poi_longitude": "-90.1261901",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 601-853-1014",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019cfb54-2864-70d3-bb80-d67b69f7c1ab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb54-2864-70d3-bb80-d67b69f7c1ab",
        "storage_key": "property/6767906449167046/019cfb54-2864-70d3-bb80-d67b69f7c1ab.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJRdCJfT7SKYYRT7E_XVattng",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "family_restaurant"
    },
    {
      "id": "custom_801f55da-7a15-4999-8bcc-407bf8f475eb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "custom",
      "poi_name": "Krilakis Ridgeland, MS",
      "poi_type": "Restaurants",
      "poi_address": "207 W Jackson St # D, Ridgeland, MS 39157, USA",
      "poi_short_description": "Casual eatery with a small patio, Greek decor & traditional meals like gyros & salads.",
      "poi_long_description": "People say this Greek restaurant serves delicious gyros, burgers, and fresh redfish. They highlight the generous portions, fast service, and clean atmosphere. They also like the option to BYOB.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d7917-437a-765a-9ca2-a6ded853f7da.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-437a-765a-9ca2-a6ded853f7da",
        "storage_key": "property/6767906449167046/019d7917-437a-765a-9ca2-a6ded853f7da.webp",
        "width": 1280,
        "height": 591
      },
      "poi_business_url": "http://krilakis.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7527911707711041918&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "krilakis-ridgeland-ms",
      "poi_latitude": "32.428425",
      "poi_longitude": "-90.1335912",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 601-790-9463",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019cfb54-2864-70d3-bb80-d67b69f7c1ab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb54-2864-70d3-bb80-d67b69f7c1ab",
        "storage_key": "property/6767906449167046/019cfb54-2864-70d3-bb80-d67b69f7c1ab.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ53-NBTSKYYRfvGeRtCDeGg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "greek_restaurant"
    },
    {
      "id": "custom_03fbcd86-484c-4813-9c86-b3f38e3adf89",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "custom",
      "poi_name": "Odyssey North Shopping Center",
      "poi_type": "Restaurants",
      "poi_address": "731 S Pear Orchard Rd, Ridgeland, MS 39157, USA",
      "poi_short_description": "Shopping venue featuring comics plus a dry cleaner, deli and podiatrist.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d7917-411f-7739-aa32-49626435db70.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-411f-7739-aa32-49626435db70",
        "storage_key": "property/6767906449167046/019d7917-411f-7739-aa32-49626435db70.webp",
        "width": 622,
        "height": 1280
      },
      "poi_business_url": "https://www.odysseynorth.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3948810214891198697&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "odyssey-north-shopping-center",
      "poi_latitude": "32.40306820000001",
      "poi_longitude": "-90.1243491",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019cfb54-2875-733b-9274-5d380b9eb81d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb54-2875-733b-9274-5d380b9eb81d",
        "storage_key": "property/6767906449167046/019cfb54-2875-733b-9274-5d380b9eb81d.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ_6R0WVjSKYYR6RgGAPj9zDY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_9797d1f3-0e32-466b-8e68-8dd024809032",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "custom",
      "poi_name": "Enter/Locked Escape Rooms",
      "poi_type": "Entertainment",
      "poi_address": "6718 Old Canton Rd, Ridgeland, MS 39157, USA",
      "poi_short_description": "Escape-game center offering five themed rooms for private group challenges.",
      "poi_long_description": "People say this amusement center offers fun and challenging escape rooms with clever puzzles. They highlight the immersive experience, unique themes, and interactive rooms. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d7917-474c-77f2-8235-b49b1b06d1a2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-474c-77f2-8235-b49b1b06d1a2",
        "storage_key": "property/6767906449167046/019d7917-474c-77f2-8235-b49b1b06d1a2.webp",
        "width": 1241,
        "height": 650
      },
      "poi_business_url": "https://www.enterlocked.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8297131859657073285&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "enter-locked-escape-rooms",
      "poi_latitude": "32.408895",
      "poi_longitude": "-90.1058825",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 601-665-3299",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019cfb54-287b-77aa-b69b-d1d32752b1e4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb54-287b-77aa-b69b-d1d32752b1e4",
        "storage_key": "property/6767906449167046/019cfb54-287b-77aa-b69b-d1d32752b1e4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZY297q7TKYYRhaJvXXdVJXM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_55e8fbb4-089d-410a-a8f6-cd1352522dbd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "custom",
      "poi_name": "Trustmark Park",
      "poi_type": "Entertainment",
      "poi_address": "1 Monsters Aly, Pearl, MS 39208, USA",
      "poi_short_description": "Circa-2005 Minor League Baseball park with bowl & picnic seating, suites, restaurant & fun center.",
      "poi_long_description": "People say this stadium offers a variety of food options, cold beer, and a fun outdoor concert experience. They highlight the great location, the nice field, and the plenty of seating. They also like the good concession stand and the availability of French fries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d7917-4bc3-77b9-9191-ce015f21a0e9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-4bc3-77b9-9191-ce015f21a0e9",
        "storage_key": "property/6767906449167046/019d7917-4bc3-77b9-9191-ce015f21a0e9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mudmonstersbaseball.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7496250163986783579&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "trustmark-park",
      "poi_latitude": "32.2732687",
      "poi_longitude": "-90.147697",
      "poi_miles_from_property": "13.7 mi",
      "poi_walking_minutes": "5 hours 2 mins",
      "poi_biking_minutes": "1 hour 21 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 601-664-7600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019cfb54-2b65-773f-963c-c9cefbbd45b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb54-2b65-773f-963c-c9cefbbd45b4",
        "storage_key": "property/6767906449167046/019cfb54-2b65-773f-963c-c9cefbbd45b4.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJQVgt8vgtKIYRW13lq84HCGg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_42295fe4-c95c-4e36-b705-6424c3298edb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "custom",
      "poi_name": "Old Trace",
      "poi_type": "Entertainment",
      "poi_address": "Unnamed Road #39157, Ridgeland, MS 39157, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d7917-53b1-7691-b7e5-b492dbc09e3a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-53b1-7691-b7e5-b492dbc09e3a",
        "storage_key": "property/6767906449167046/019d7917-53b1-7691-b7e5-b492dbc09e3a.webp",
        "width": 1280,
        "height": 958
      },
      "poi_business_url": "https://npplan.com/parks-by-state/mississippi-national-parks/natchez-trace-parkway-park-at-a-glance/natchez-trace-parkway-hiking-trails/natchez-trace-parkway-old-trace-and-brashears-stand-mp-104-5/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14989083696698533799&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "old-trace",
      "poi_latitude": "32.424649",
      "poi_longitude": "-90.0890086",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 601-856-6574",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019cfb54-2b97-753d-8ac2-646d4ab3de71.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb54-2b97-753d-8ac2-646d4ab3de71",
        "storage_key": "property/6767906449167046/019cfb54-2b97-753d-8ac2-646d4ab3de71.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1XPJUOvTKYYRp6dQ4jTsA9A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_881bd9bf-6902-4b38-9cf8-9c5bd3964384",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "custom",
      "poi_name": "Friendship Park",
      "poi_type": "Entertainment",
      "poi_address": "475 Lake Harbour Dr, Ridgeland, MS 39157, USA",
      "poi_short_description": "Relaxed park with a playground, swings, slides and fitness equipment plus picnic tables and walking trails.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019d7917-531c-769c-9fac-ae8c80e26568.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-531c-769c-9fac-ae8c80e26568",
        "storage_key": "property/6767906449167046/019d7917-531c-769c-9fac-ae8c80e26568.webp",
        "width": 1280,
        "height": 961
      },
      "poi_business_url": "https://www.ridgelandms.org/city-departments/recreation-and-parks/facilities/#Friendship-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=12704319735673983707&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "friendship-park",
      "poi_latitude": "32.412771",
      "poi_longitude": "-90.1208439",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 601-853-2011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019cfb54-2b97-753d-8ac2-646d4ab3de71.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb54-2b97-753d-8ac2-646d4ab3de71",
        "storage_key": "property/6767906449167046/019cfb54-2b97-753d-8ac2-646d4ab3de71.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3Rc3SLXTKYYR2xLVPX3PTrA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    }
  ],
  "office_hours": [
    {
      "id": "ec_0d76a7b58e50654cb59df177",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_63f5ea245adf52b78e8aa5c1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_dfb6c5c010d4e43ed7d13086",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_c08533dc94b237d8ce54ee76",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:00"
    },
    {
      "id": "ec_e520174367134d2a2eb75781",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "15:00"
    },
    {
      "id": "ec_a40152a2849459a1372da4c5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    }
  ],
  "reviews": [
    {
      "id": "custom_40583e80-0be9-4b9e-b114-a7f9b1b6297c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "rating": "5.0",
      "name": "Alex Willis",
      "text": "Liz and every staff member I interacting with in passing were above and beyond courteous during the move in process. The grounds and unit were pristine. The fiber internet plan available was a pleasant surprise. The only ding against this complex are outdated (but functional) appliances and light fixtures. But that is a compromise I think I’ll be happy to make.",
      "date": "2026-01-21",
      "title": ""
    },
    {
      "id": "custom_21d8f1b0-bb23-40f7-9078-ca802ce257fd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "rating": "5.0",
      "name": "Kim Beasley",
      "text": "The property manager and staff do a great job. The  Property stays neat and clean. The Pointe is a pleasant and safe place to live because of  their dedication and their efficient work. The office staff is friendly and attentive. The maintenance workers are hard working and respectful.  No complaints!",
      "date": "2025-09-02",
      "title": ""
    },
    {
      "id": "custom_05511312-f918-418d-a90e-35edc80627d6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "rating": "5.0",
      "name": "Karen Jeselink",
      "text": "Very well taken care of so nothing terrible but there are several light posts in the parking lot that are out and lights in breeze ways/doors out as well. I want to feel safe in the parking lot and common spaces",
      "date": "2025-11-19",
      "title": ""
    },
    {
      "id": "custom_b24615c6-8d05-4fd0-beeb-c0cbf4ed6999",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "rating": "5.0",
      "name": "Rigoberto Alonzo",
      "text": "A quiet and comfortable place to live surrounded by nature. The process is easy, and the customer service is excellent. They're the best. 🙏🏻😌",
      "date": "2025-10-06",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_1197a77d-8299-46fd-abb9-8861babf8a29",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167046/019cfb54-b506-777e-87d0-eff82a337bab.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "360 virtual tour of the community pool and building exterior",
        "public_id": "019cfb54-b506-777e-87d0-eff82a337bab",
        "storage_key": "property/6767906449167046/019cfb54-b506-777e-87d0-eff82a337bab.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Pointe of Ridgeland Virtual Tour",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=5f8f379ab00cad1961726026"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019cf79e-566e-74c5-8e4e-6eb122a35231",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "the-pointe-of-ridgeland",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046"
    },
    {
      "lead_collector_id": "019cf79e-56e4-74fa-a16c-7ee9cfd05a13",
      "lead_source": "LANDING_PAGE",
      "name": "the-pointe-of-ridgeland",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "generator",
      "page_item_url": "apartments-with-dog-park-ridgeland-ms-pointe-of-ridgeland",
      "search_query": "apartments with dog park ridgeland ms",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments in Ridgeland, MS",
      "h2_subtitle": "Discover pet-friendly living at The Pointe of Ridgeland. Our community amenities and spacious layouts make it ideal for you and your furry friends.",
      "page_copy": "Welcome to The Pointe of Ridgeland, where we understand that pets are part of the family. While our apartments offer spacious living with amenities like ceiling fans and carpeting, we also ensure that your furry companions enjoy their time here too. Although we don't have a dedicated dog park, our community is pet-friendly, offering plenty of walkable areas around Ridgeland, MS.\n\nOur vibrant community is located in picturesque Madison County, providing easy access to nearby parks and trails perfect for walking your dog. Inside, you'll find features designed for comfort and convenience, such as washer/dryer connections and a business center. We invite you to explore a pet-friendly lifestyle at The Pointe of Ridgeland.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments in Ridgeland, MS",
      "seo_description": "Explore pet-friendly living at The Pointe of Ridgeland in MS. Enjoy spacious apartments and a welcoming community for you and your pets.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "generator",
      "page_item_url": "poolside-apartments-madison-county-pointe-of-ridgeland",
      "search_query": "poolside apartments madison county",
      "category": "Amenity",
      "h1_title": "Poolside Living in Madison County",
      "h2_subtitle": "Experience poolside comfort at The Pointe of Ridgeland. Enjoy a serene lifestyle with our exceptional amenities.",
      "page_copy": "The Pointe of Ridgeland invites you to enjoy poolside living in Madison County. While our community does not feature a pool, we ensure a relaxing environment with other exceptional amenities like a 24-hour fitness center and a well-equipped business center. Nestled in Ridgeland, MS, our apartments provide a perfect blend of comfort and convenience tailored to your lifestyle.\n\nIn addition to enjoying the energetic and serene spots around Madison County, residents benefit from in-apartment features including ceiling fans, carpeting, and convenient washer/dryer connections. Our location offers easy access to local entertainment and dining, ensuring you have everything you need nearby. Discover a lifestyle elevated by The Pointe of Ridgeland’s amenities.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Poolside Apartments in Madison County",
      "seo_description": "Discover comfortable living at The Pointe of Ridgeland in Madison County, MS. Explore our amenities designed for a serene lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "generator",
      "page_item_url": "24-hour-fitness-center-apartments-ridgeland-ms",
      "search_query": "24 hour fitness center in ridgeland",
      "category": "Amenity",
      "h1_title": "24-Hour Fitness Center in Ridgeland",
      "h2_subtitle": "Stay fit anytime at The Pointe of Ridgeland. Our 24-hour fitness center ensures you can work out on your schedule.",
      "page_copy": "At The Pointe of Ridgeland, a healthy lifestyle is within reach. Our community features a 24-hour fitness center, allowing you to maintain your fitness routine at any hour that suits your schedule. Located in the heart of Ridgeland, MS, our fitness center is equipped with modern equipment to cater to all workout preferences, from cardio to strength training.\n\nBeyond our fitness amenities, residents enjoy the comfort of thoughtfully designed apartments complete with essential features like ceiling fans and washer/dryer connections. Our prime location in Madison County provides access to nearby parks and recreational areas, offering even more opportunities to stay active. Experience the convenience and flexibility of fitness-focused living at The Pointe of Ridgeland.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "24-Hour Fitness Center Apartments in Ridgeland",
      "seo_description": "Enjoy a flexible fitness routine at The Pointe of Ridgeland, offering a 24-hour fitness center and modern amenities in Ridgeland, MS.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "generator",
      "page_item_url": "business-center-apartments-39157-ridgeland",
      "search_query": "business center apartments 39157",
      "category": "Amenity",
      "h1_title": "Business Center Apartments in 39157",
      "h2_subtitle": "Work efficiently at The Pointe of Ridgeland. Our on-site business center provides the ideal space for productivity.",
      "page_copy": "Discover The Pointe of Ridgeland, where work and living seamlessly blend in our business center-equipped community. Located in the 39157 zip code, our apartments cater to professionals seeking a conducive environment for both relaxation and productivity. Our on-site business center is perfect for remote work, study sessions, and meetings, offering residents a convenient workspace just steps from their front door.\n\nIn addition to our business-friendly amenities, our apartments feature modern conveniences like ceiling fans, carpeting, and washer/dryer connections. Reside in a thriving community with easy access to local dining and shopping options in the heart of Madison County. Make The Pointe of Ridgeland your home for comfortable and productive living.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Business Center Apartments in 39157, Ridgeland",
      "seo_description": "Explore business center apartments at The Pointe of Ridgeland, located in the 39157 area. Ideal for professionals seeking convenience and productivity.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "generator",
      "page_item_url": "private-balcony-apartments-madison-county-ridgeland",
      "search_query": "private balcony apartments madison county",
      "category": "Amenity",
      "h1_title": "Private Balcony Apartments in Madison County",
      "h2_subtitle": "Unwind with a private balcony at The Pointe of Ridgeland. Enjoy tranquil views and outdoor relaxation in Madison County.",
      "page_copy": "While The Pointe of Ridgeland does not currently feature private balconies, our community remains a haven for those seeking serene living in Madison County. Residents can take advantage of our beautiful surroundings and outdoor spaces that offer a breath of fresh air daily. Located in the vibrant city of Ridgeland, MS, our property combines comfort and convenience.\n\nThe Pointe of Ridgeland boasts well-appointed interiors that include ceiling fans, carpeting, and washer/dryer connections. Our prime location provides quick access to local attractions and parks in Madison County, making outdoor leisure readily available. Embrace a lifestyle of relaxation and accessibility at The Pointe of Ridgeland.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Private Balcony Apartments in Madison County",
      "seo_description": "Experience outdoor living at The Pointe of Ridgeland. Though without private balconies, enjoy the ease and tranquility of Madison County.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-ridgeland-ms",
      "search_query": "one bedroom apartments ridgeland ms",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Ridgeland, MS",
      "h2_subtitle": "Discover comfort at The Pointe of Ridgeland. Our one bedroom apartments in Ridgeland, MS, offer spacious living and modern amenities.",
      "page_copy": "Explore the inviting one bedroom apartments at The Pointe of Ridgeland, ideally located in the heart of Ridgeland, MS. Each apartment is designed with comfort in mind, featuring essential amenities like ceiling fans and washer/dryer connections that enhance everyday living. Our apartments provide the perfect blend of space and style, ideal for singles or couples looking to settle in a vibrant community.\n\nResidents enjoy not only the convenience of modern home features but also access to a robust set of amenities, including a 24-hour fitness center and business center. Nestled in beautiful Madison County, our location ensures easy access to local parks, shopping, and dining, making The Pointe of Ridgeland an excellent choice for one bedroom living.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Ridgeland, MS",
      "seo_description": "Find your new home at The Pointe of Ridgeland. Spacious one bedroom apartments with modern features in Ridgeland, MS.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-madison-county-ridgeland",
      "search_query": "two bedroom apartments madison county",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Madison County",
      "h2_subtitle": "Spacious living awaits at The Pointe of Ridgeland. Explore our two bedroom apartments in Madison County for modern comfort and convenience.",
      "page_copy": "Located in the scenic Madison County, The Pointe of Ridgeland offers two bedroom apartments that prioritize your comfort and lifestyle. Each unit is thoughtfully designed with features that make daily living a breeze, including ceiling fans, plush carpeting, and washer/dryer connections. Our two bedroom layouts are perfect for families, roommates, or those needing extra space while enjoying all the conveniences of Ridgeland, MS.\n\nBeyond the doorsteps of your apartment, you'll discover a community rich in amenities like a 24-hour fitness center and a fully-equipped business center for all your work-from-home needs. The Pointe of Ridgeland is a stone's throw away from shopping, dining, and outdoor recreation, making it the ideal spot to experience all that Madison County offers. Welcome home to comfort and accessibility.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Madison County",
      "seo_description": "Discover spacious two bedroom apartments at The Pointe of Ridgeland in Madison County. Enjoy modern living with top amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-near-39157-ridgeland",
      "search_query": "three bedroom apartments near 39157",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments Near 39157",
      "h2_subtitle": "Experience The Pointe of Ridgeland living. Our three bedroom apartments near the 39157 area offer ample space for families and professionals alike.",
      "page_copy": "At The Pointe of Ridgeland, find spacious three bedroom apartments perfectly suited for families or those seeking extra room near the 39157 area. Designed with modern comforts in mind, these apartments feature ceiling fans for cooling efficiency, carpeting for a cozy feel, and in-unit washer/dryer connections that add convenience to your daily routine.\n\nOur community is not just about space; it's about lifestyle. With stellar amenities like a 24-hour fitness center and a business center, you'll have everything you need right at your doorstep. Nestled in Madison County, our location provides easy access to Ridgeland's best shopping, dining, and recreational spots, making The Pointe of Ridgeland an exceptional choice for those looking to experience comfort and convenience close to home.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments Near 39157",
      "seo_description": "Find spacious three bedroom apartments near the 39157 area at The Pointe of Ridgeland. Enjoy amenities and convenient access to local attractions.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "generator",
      "page_item_url": "apartments-near-holmes-community-college-ms",
      "search_query": "apartments near holmes community college MS",
      "category": "School",
      "h1_title": "Apartments Near Holmes Community College MS",
      "h2_subtitle": "Discover convenience at The Pointe of Ridgeland. Our apartments near Holmes Community College, MS, offer modern amenities and a welcoming community.",
      "page_copy": "If you're searching for comfortable apartments near Holmes Community College MS, look no further than The Pointe of Ridgeland. Situated within a convenient distance, our community is perfect for students, faculty, or professionals seeking quality living with efficient access to the college campus. Our modern apartments feature ceiling fans, plush carpeting, and the practical addition of washer/dryer connections to enhance your daily lifestyle.\n\nResidents at The Pointe of Ridgeland enjoy a host of amenities, including a 24-hour fitness center that caters to all schedules and a business center ideal for studying or remote work. Conveniently located in Madison County, our community provides easy access to local dining, shopping, and entertainment options, ensuring a balanced lifestyle between work, school, and leisure.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Holmes Community College MS",
      "seo_description": "Explore apartments near Holmes Community College MS at The Pointe of Ridgeland. Enjoy modern living with great amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "generator",
      "page_item_url": "apartments-close-to-tougaloo-college-madison-county",
      "search_query": "apartments close to tougaloo college madison county",
      "category": "School",
      "h1_title": "Apartments Close to Tougaloo College",
      "h2_subtitle": "Explore The Pointe of Ridgeland, ideally located. Our apartments in Madison County are close to Tougaloo College, offering modern comforts and convenience.",
      "page_copy": "Discover the ideal location at The Pointe of Ridgeland, where our apartments offer the ideal setting and proximity for those attending or working at Tougaloo College. Located in the vibrant Madison County, our community is a short commute away, making it a prime choice for students and staff alike. Our apartments provide modern amenities like ceiling fans, washer/dryer connections, and comfortable carpeting, ensuring a cozy and convenient living experience.\n\nBeyond our comfortable living spaces, residents can take advantage of a 24-hour fitness center and a well-equipped business center, catering to both active lifestyles and professional needs. Situated in a prime area, The Pointe of Ridgeland offers easy access to local attractions, dining, and shopping, ensuring you’re close to both academic and leisure pursuits.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Tougaloo College",
      "seo_description": "Find apartments close to Tougaloo College at The Pointe of Ridgeland in Madison County. Enjoy modern amenities and a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "generator",
      "page_item_url": "apartments-near-merit-health-womans-hospital-ridgeland-ms",
      "search_query": "apartments near Merit Health Woman's Hospital Ridgeland MS",
      "category": "Hospital",
      "h1_title": "Apartments Near Merit Health Woman's Hospital",
      "h2_subtitle": "Stay close to essential healthcare. Our apartments in Ridgeland, MS, are conveniently near Merit Health Woman's Hospital, offering comfort and modern amenities.",
      "page_copy": "The Pointe of Ridgeland offers ideal apartment living close to Merit Health Woman's Hospital in Ridgeland, MS. Our community provides the perfect blend of comfort and convenience for healthcare professionals, patients, or visitors who prioritize proximity to the hospital. With features like ceiling fans, plush carpeting, and washer/dryer connections, our apartments ensure a comfortable lifestyle that meets modern needs.\n\nResidents benefit from access to superb amenities, including a 24-hour fitness center and a business center, making it easy to stay fit and productive. Located in the vibrant Madison County, The Pointe of Ridgeland is surrounded by Ridgeland's best dining, shopping, and leisure spots, offering a balanced lifestyle that caters to both professional and personal pursuits.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Merit Health Woman's Hospital",
      "seo_description": "Discover convenient apartments near Merit Health Woman's Hospital in Ridgeland, MS, at The Pointe of Ridgeland. Enjoy comfort and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "generator",
      "page_item_url": "apartments-close-to-select-specialty-hospital-jackson",
      "search_query": "apartments close to Select Specialty Hospital Jackson Madison County",
      "category": "Hospital",
      "h1_title": "Apartments Close to Select Specialty Hospital",
      "h2_subtitle": "Find modern amenities and convenience at The Pointe of Ridgeland. Our apartments are close to Select Specialty Hospital in Jackson, Madison County.",
      "page_copy": "At The Pointe of Ridgeland, discover convenience and comfort with our apartments close to Select Specialty Hospital Jackson in Madison County. Perfectly located for healthcare professionals and families, our community offers easy access to the hospital, ensuring you are never far from where you need to be. Each apartment is thoughtfully designed with features like ceiling fans, cozy carpeting, and efficient washer/dryer connections.\n\nOur community enriches your living experience by offering a 24-hour fitness center and a business center, catering to various lifestyle needs. Situated in Madison County, The Pointe of Ridgeland allows residents to enjoy nearby shopping, dining, and entertainment, making it a vibrant place that balances work and leisure seamlessly.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Select Specialty Hospital",
      "seo_description": "Explore apartments close to Select Specialty Hospital Jackson at The Pointe of Ridgeland in Madison County. Enjoy convenience and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "generator",
      "page_item_url": "apartments-near-freedom-ridge-ridgeland",
      "search_query": "apartments near Freedom Ridge Ridgeland",
      "category": "Park",
      "h1_title": "Apartments Near Freedom Ridge, Ridgeland",
      "h2_subtitle": "Enjoy the scenic beauty of Freedom Ridge Park. Our Ridgeland apartments are conveniently located near Freedom Ridge, offering comfort and accessibility.",
      "page_copy": "The Pointe of Ridgeland offers a vibrant living experience near the picturesque Freedom Ridge Park in Ridgeland. With nature trails and recreational facilities just a stone's throw away, our community is perfect for those who enjoy the outdoors. Our apartments are equipped with modern amenities including ceiling fans, plush carpeting, and washer/dryer connections, designed for ultimate comfort.\n\nResidents have access to a 24-hour fitness center and a business center, promoting a balanced lifestyle of health and productivity. Nestled in the heart of Ridgeland, The Pointe of Ridgeland ensures you are close to the action, whether it be exploring local attractions, shopping, or dining. Experience the convenience and charm of living near Freedom Ridge Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Freedom Ridge in Ridgeland",
      "seo_description": "Find convenient apartments near Freedom Ridge Park at The Pointe of Ridgeland. Enjoy nature and modern amenities in the heart of Ridgeland.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "generator",
      "page_item_url": "apartments-close-to-winners-circle-park-39157",
      "search_query": "apartments close to Winners Circle Park 39157",
      "category": "Park",
      "h1_title": "Apartments Close to Winners Circle Park",
      "h2_subtitle": "Experience vibrant living at The Pointe of Ridgeland. Our apartments are close to Winners Circle Park, located in the 39157 area, perfect for outdoor enthusiasts.",
      "page_copy": "Discover the perfect blend of outdoor charm and modern living at The Pointe of Ridgeland, offering apartments close to Winners Circle Park in the 39157 area. Ideal for families and individuals who love outdoor activities, Winners Circle Park provides a beautiful setting for both relaxation and recreation. Our apartments feature thoughtful amenities like ceiling fans, cozy carpeting, and efficient washer/dryer connections, ensuring a comfortable home life.\n\nStay active with our 24-hour fitness center or focus on work in our business center, catering to all facets of life. Positioned within Madison County’s lively community, The Pointe of Ridgeland provides residents with easy access to local dining, shopping, and entertainment venues, making it the perfect place to call home in Ridgeland.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Winners Circle Park, 39157",
      "seo_description": "Explore apartments close to Winners Circle Park in the 39157 area at The Pointe of Ridgeland. Enjoy outdoor beauty and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "generator",
      "page_item_url": "apartments-by-old-trace-park-madison-county",
      "search_query": "apartments by Old Trace Park Madison County",
      "category": "Park",
      "h1_title": "Apartments by Old Trace Park",
      "h2_subtitle": "Live near the scenic Old Trace Park in Madison County. Our apartments by Old Trace Park offer modern comforts and a convenient location for all lifestyles.",
      "page_copy": "The Pointe of Ridgeland presents ideal living in close proximity to Old Trace Park, Madison County's gem. This vibrant park offers a beautiful setting with access to the scenic Ross Barnett Reservoir, perfect for picnics, boating, and nature walks. Our community is perfect for those seeking both outdoor adventures and modern conveniences.\n\nEnjoy our amenities such as a 24-hour fitness center and a business center, designed to enhance your lifestyle. Each apartment is equipped with features like ceiling fans, soft carpeting, and washer/dryer connections. Situated in a dynamic locale, The Pointe of Ridgeland provides easy access to shopping, dining, and entertainment, making it the ideal place for a balanced and enriched living experience.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Old Trace Park, Madison County",
      "seo_description": "Find apartments by Old Trace Park in Madison County at The Pointe of Ridgeland. Enjoy modern comforts and scenic outdoor views.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "generator",
      "page_item_url": "apartments-nearby-flowood-liberty-park-ms",
      "search_query": "apartments nearby Flowood Liberty Park MS",
      "category": "Park",
      "h1_title": "Apartments Near Flowood Liberty Park",
      "h2_subtitle": "Explore spacious living near Flowood Liberty Park. Our apartments nearby in Ridgeland, MS offer easy access to the vibrant scenes of Flowood.",
      "page_copy": "Situated comfortably in Ridgeland, The Pointe of Ridgeland offers an excellent living experience with easy accessibility to Flowood Liberty Park, MS. Perfect for families and outdoor enthusiasts, this nearby park provides ample green space for picnics and sports activities. Our apartments are designed for comfort and functionality with features like ceiling fans, plush carpeting, and washer/dryer connections.\n\nThe community includes amenities such as a 24-hour fitness center and a business center, ensuring you have everything you need close to home. Living at The Pointe of Ridgeland means you are strategically positioned to enjoy not only the beautiful parks but also the plethora of shopping, dining, and entertainment options available in the surrounding area, making it an ideal location for all.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Flowood Liberty Park, MS",
      "seo_description": "Discover apartments nearby Flowood Liberty Park, MS, at The Pointe of Ridgeland. Enjoy modern amenities and a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167046",
      "source": "generator",
      "page_item_url": "apartments-close-to-flowood-nature-park-ridgeland",
      "search_query": "apartments close to Flowood Nature Park Ridgeland",
      "category": "Park",
      "h1_title": "Apartments Close to Flowood Nature Park",
      "h2_subtitle": "Discover homes near Flowood Nature Park. Our apartments in Ridgeland offer proximity to nature and modern convenience, perfect for active lifestyles.",
      "page_copy": "At The Pointe of Ridgeland, find idyllic apartments close to Flowood Nature Park, a natural haven perfect for those who love to unwind amidst serene landscapes. Just a short drive from Ridgeland, Flowood Nature Park offers a peaceful retreat with walking trails and green spaces ideal for leisurely strolls or morning jogs. Our community provides a seamless blend of nature and urban living.\n\nEnjoy apartment features such as cozy carpeting, ceiling fans, and washer/dryer connections. Complementing your active lifestyle, our amenities also include a 24-hour fitness center and a modern business center. Located in a vibrant neighborhood, The Pointe of Ridgeland allows easy access to local dining, shopping, and entertainment venues, making it the perfect spot to experience the best of both worlds.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Flowood Nature Park",
      "seo_description": "Explore apartments close to Flowood Nature Park in Ridgeland. Enjoy nature and modern amenities at The Pointe of Ridgeland.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "6173"
    },
    {
      "ID": "custom_ga4_id",
      "type": "STRING",
      "value": "G-E1BNWTE72C"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "10041151880"
    },
    {
      "ID": "custom_tour24_url",
      "type": "STRING",
      "value": "https://app.tour24now.com/prospect/tour/the-pointe-of-ridgeland/register/"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-NFDD6MBK"
    },
    {
      "ID": "custom_floorplan_pdf_url",
      "type": "STRING",
      "value": "https://multihubmedia.com/property/6767906449167046/019d1bda-6bed-754d-ab7f-16cc041f66e2.pdf"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "5064029900"
    },
    {
      "ID": "custom_rentgrata_property_id",
      "type": "STRING",
      "value": "f0b658bb-a349-4fb8-bdb0-5b650dafbd14"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "866-788-0572"
    },
    {
      "ID": "custom_residentboost_apartment_id",
      "type": "STRING",
      "value": "6504af6f8f74d3493421dc5e"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IjVWL2FvU0dtTWlCaUsyM0JJYnZTT2c9PSIsInZhbHVlIjoibWVMcjhyRVk1R0dTT0UrNXJycFlBUT09IiwibWFjIjoiNjM4ZTM4ZjgyZjZjN2Y2OTQ4YzBhYTliOTdmYTlhMjhkMmMzMmI3ZDJkZjMxMmEyMmFmYzdiNThmOWYxNTU4NyJ9"
    }
  ],
  "custom_qb_id": "6173",
  "custom_ga4_id": "G-E1BNWTE72C",
  "custom_repli_id": "10041151880",
  "custom_tour24_url": "https://app.tour24now.com/prospect/tour/the-pointe-of-ridgeland/register/",
  "custom_google_gtm_id": "GTM-NFDD6MBK",
  "custom_floorplan_pdf_url": "https://multihubmedia.com/property/6767906449167046/019d1bda-6bed-754d-ab7f-16cc041f66e2.pdf",
  "custom_hubspot_company_id": "5064029900",
  "custom_rentgrata_property_id": "f0b658bb-a349-4fb8-bdb0-5b650dafbd14",
  "custom_ppc_tracking_phone_number": "866-788-0572",
  "custom_residentboost_apartment_id": "6504af6f8f74d3493421dc5e",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IjVWL2FvU0dtTWlCaUsyM0JJYnZTT2c9PSIsInZhbHVlIjoibWVMcjhyRVk1R0dTT0UrNXJycFlBUT09IiwibWFjIjoiNjM4ZTM4ZjgyZjZjN2Y2OTQ4YzBhYTliOTdmYTlhMjhkMmMzMmI3ZDJkZjMxMmEyMmFmYzdiNThmOWYxNTU4NyJ9"
};

export const generatedAt = '2026-08-27T21:32:38.588Z';
